import { BOOKS, VERSIONS } from "../../utils/constants";
import { Scripture } from "../types";

export const SecondChronicles: Scripture = {
  version: VERSIONS.KJV,
  book: BOOKS.SECOND_CHRONICLES,
  chapters: [
    {
      chapter: "1",
      verses: [
        {
          verse: "1",
          text: "And Solomon the son of David was strengthened in his kingdom, and the LORD his God was with him, and magnified him exceedingly.",
        },
        {
          verse: "2",
          text: "Then Solomon spake unto all Israel, to the captains of thousands and of hundreds, and to the judges, and to every governor in all Israel, the chief of the fathers.",
        },
        {
          verse: "3",
          text: "So Solomon, and all the congregation with him, went to the high place that was at Gibeon; for there was the tabernacle of the congregation of God, which Moses the servant of the LORD had made in the wilderness.",
        },
        {
          verse: "4",
          text: "But the ark of God had David brought up from Kirjathjearim to the place which David had prepared for it: for he had pitched a tent for it at Jerusalem.",
        },
        {
          verse: "5",
          text: "Moreover the brasen altar, that Bezaleel the son of Uri, the son of Hur, had made, he put before the tabernacle of the LORD: and Solomon and the congregation sought unto it.",
        },
        {
          verse: "6",
          text: "And Solomon went up thither to the brasen altar before the LORD, which was at the tabernacle of the congregation, and offered a thousand burnt offerings upon it.",
        },
        {
          verse: "7",
          text: "In that night did God appear unto Solomon, and said unto him, Ask what I shall give thee.",
        },
        {
          verse: "8",
          text: "And Solomon said unto God, Thou hast shewed great mercy unto David my father, and hast made me to reign in his stead.",
        },
        {
          verse: "9",
          text: "Now, O LORD God, let thy promise unto David my father be established: for thou hast made me king over a people like the dust of the earth in multitude.",
        },
        {
          verse: "10",
          text: "Give me now wisdom and knowledge, that I may go out and come in before this people: for who can judge this thy people, that is so great?",
        },
        {
          verse: "11",
          text: "And God said to Solomon, Because this was in thine heart, and thou hast not asked riches, wealth, or honour, nor the life of thine enemies, neither yet hast asked long life; but hast asked wisdom and knowledge for thyself, that thou mayest judge my people, over whom I have made thee king:",
        },
        {
          verse: "12",
          text: "Wisdom and knowledge is granted unto thee; and I will give thee riches, and wealth, and honour, such as none of the kings have had that have been before thee, neither shall there any after thee have the like.",
        },
        {
          verse: "13",
          text: "Then Solomon came from his journey to the high place that was at Gibeon to Jerusalem, from before the tabernacle of the congregation, and reigned over Israel.",
        },
        {
          verse: "14",
          text: "And Solomon gathered chariots and horsemen: and he had a thousand and four hundred chariots, and twelve thousand horsemen, which he placed in the chariot cities, and with the king at Jerusalem.",
        },
        {
          verse: "15",
          text: "And the king made silver and gold at Jerusalem as plenteous as stones, and cedar trees made he as the sycomore trees that are in the vale for abundance.",
        },
        {
          verse: "16",
          text: "And Solomon had horses brought out of Egypt, and linen yarn: the king\u2019s merchants received the linen yarn at a price.",
        },
        {
          verse: "17",
          text: "And they fetched up, and brought forth out of Egypt a chariot for six hundred shekels of silver, and an horse for an hundred and fifty: and so brought they out horses for all the kings of the Hittites, and for the kings of Syria, by their means.",
        },
      ],
    },
    {
      chapter: "2",
      verses: [
        {
          verse: "1",
          text: "And Solomon determined to build an house for the name of the LORD, and an house for his kingdom.",
        },
        {
          verse: "2",
          text: "And Solomon told out threescore and ten thousand men to bear burdens, and fourscore thousand to hew in the mountain, and three thousand and six hundred to oversee them.",
        },
        {
          verse: "3",
          text: "And Solomon sent to Huram the king of Tyre, saying, As thou didst deal with David my father, and didst send him cedars to build him an house to dwell therein, even so deal with me.",
        },
        {
          verse: "4",
          text: "Behold, I build an house to the name of the LORD my God, to dedicate it to him, and to burn before him sweet incense, and for the continual shewbread, and for the burnt offerings morning and evening, on the sabbaths, and on the new moons, and on the solemn feasts of the LORD our God. This is an ordinance for ever to Israel.",
        },
        {
          verse: "5",
          text: "And the house which I build is great: for great is our God above all gods.",
        },
        {
          verse: "6",
          text: "But who is able to build him an house, seeing the heaven and heaven of heavens cannot contain him? who am I then, that I should build him an house, save only to burn sacrifice before him?",
        },
        {
          verse: "7",
          text: "Send me now therefore a man cunning to work in gold, and in silver, and in brass, and in iron, and in purple, and crimson, and blue, and that can skill to grave with the cunning men that are with me in Judah and in Jerusalem, whom David my father did provide.",
        },
        {
          verse: "8",
          text: "Send me also cedar trees, fir trees, and algum trees, out of Lebanon: for I know that thy servants can skill to cut timber in Lebanon; and, behold, my servants shall be with thy servants,",
        },
        {
          verse: "9",
          text: "Even to prepare me timber in abundance: for the house which I am about to build shall be wonderful great.",
        },
        {
          verse: "10",
          text: "And, behold, I will give to thy servants, the hewers that cut timber, twenty thousand measures of beaten wheat, and twenty thousand measures of barley, and twenty thousand baths of wine, and twenty thousand baths of oil.",
        },
        {
          verse: "11",
          text: "Then Huram the king of Tyre answered in writing, which he sent to Solomon, Because the LORD hath loved his people, he hath made thee king over them.",
        },
        {
          verse: "12",
          text: "Huram said moreover, Blessed be the LORD God of Israel, that made heaven and earth, who hath given to David the king a wise son, endued with prudence and understanding, that might build an house for the LORD, and an house for his kingdom.",
        },
        {
          verse: "13",
          text: "And now I have sent a cunning man, endued with understanding, of Huram my father\u2019s,",
        },
        {
          verse: "14",
          text: "The son of a woman of the daughters of Dan, and his father was a man of Tyre, skilful to work in gold, and in silver, in brass, in iron, in stone, and in timber, in purple, in blue, and in fine linen, and in crimson; also to grave any manner of graving, and to find out every device which shall be put to him, with thy cunning men, and with the cunning men of my lord David thy father.",
        },
        {
          verse: "15",
          text: "Now therefore the wheat, and the barley, the oil, and the wine, which my lord hath spoken of, let him send unto his servants:",
        },
        {
          verse: "16",
          text: "And we will cut wood out of Lebanon, as much as thou shalt need: and we will bring it to thee in floats by sea to Joppa; and thou shalt carry it up to Jerusalem.",
        },
        {
          verse: "17",
          text: "And Solomon numbered all the strangers that were in the land of Israel, after the numbering wherewith David his father had numbered them; and they were found an hundred and fifty thousand and three thousand and six hundred.",
        },
        {
          verse: "18",
          text: "And he set threescore and ten thousand of them to be bearers of burdens, and fourscore thousand to be hewers in the mountain, and three thousand and six hundred overseers to set the people a work.",
        },
      ],
    },
    {
      chapter: "3",
      verses: [
        {
          verse: "1",
          text: "Then Solomon began to build the house of the LORD at Jerusalem in mount Moriah, where the Lord appeared unto David his father, in the place that David had prepared in the threshingfloor of Ornan the Jebusite.",
        },
        {
          verse: "2",
          text: "And he began to build in the second day of the second month, in the fourth year of his reign.",
        },
        {
          verse: "3",
          text: "Now these are the things wherein Solomon was instructed for the building of the house of God. The length by cubits after the first measure was threescore cubits, and the breadth twenty cubits.",
        },
        {
          verse: "4",
          text: "And the porch that was in the front of the house, the length of it was according to the breadth of the house, twenty cubits, and the height was an hundred and twenty: and he overlaid it within with pure gold.",
        },
        {
          verse: "5",
          text: "And the greater house he cieled with fir tree, which he overlaid with fine gold, and set thereon palm trees and chains.",
        },
        {
          verse: "6",
          text: "And he garnished the house with precious stones for beauty: and the gold was gold of Parvaim.",
        },
        {
          verse: "7",
          text: "He overlaid also the house, the beams, the posts, and the walls thereof, and the doors thereof, with gold; and graved cherubims on the walls.",
        },
        {
          verse: "8",
          text: "And he made the most holy house, the length whereof was according to the breadth of the house, twenty cubits, and the breadth thereof twenty cubits: and he overlaid it with fine gold, amounting to six hundred talents.",
        },
        {
          verse: "9",
          text: "And the weight of the nails was fifty shekels of gold. And he overlaid the upper chambers with gold.",
        },
        {
          verse: "10",
          text: "And in the most holy house he made two cherubims of image work, and overlaid them with gold.",
        },
        {
          verse: "11",
          text: "And the wings of the cherubims were twenty cubits long: one wing of the one cherub was five cubits, reaching to the wall of the house: and the other wing was likewise five cubits, reaching to the wing of the other cherub.",
        },
        {
          verse: "12",
          text: "And one wing of the other cherub was five cubits, reaching to the wall of the house: and the other wing was five cubits also, joining to the wing of the other cherub.",
        },
        {
          verse: "13",
          text: "The wings of these cherubims spread themselves forth twenty cubits: and they stood on their feet, and their faces were inward.",
        },
        {
          verse: "14",
          text: "And he made the vail of blue, and purple, and crimson, and fine linen, and wrought cherubims thereon.",
        },
        {
          verse: "15",
          text: "Also he made before the house two pillars of thirty and five cubits high, and the chapiter that was on the top of each of them was five cubits.",
        },
        {
          verse: "16",
          text: "And he made chains, as in the oracle, and put them on the heads of the pillars; and made an hundred pomegranates, and put them on the chains.",
        },
        {
          verse: "17",
          text: "And he reared up the pillars before the temple, one on the right hand, and the other on the left; and called the name of that on the right hand Jachin, and the name of that on the left Boaz.",
        },
      ],
    },
    {
      chapter: "4",
      verses: [
        {
          verse: "1",
          text: "Moreover he made an altar of brass, twenty cubits the length thereof, and twenty cubits the breadth thereof, and ten cubits the height thereof.",
        },
        {
          verse: "2",
          text: "Also he made a molten sea of ten cubits from brim to brim, round in compass, and five cubits the height thereof; and a line of thirty cubits did compass it round about.",
        },
        {
          verse: "3",
          text: "And under it was the similitude of oxen, which did compass it round about: ten in a cubit, compassing the sea round about. Two rows of oxen were cast, when it was cast.",
        },
        {
          verse: "4",
          text: "It stood upon twelve oxen, three looking toward the north, and three looking toward the west, and three looking toward the south, and three looking toward the east: and the sea was set above upon them, and all their hinder parts were inward.",
        },
        {
          verse: "5",
          text: "And the thickness of it was an handbreadth, and the brim of it like the work of the brim of a cup, with flowers of lilies; and it received and held three thousand baths.",
        },
        {
          verse: "6",
          text: "He made also ten lavers, and put five on the right hand, and five on the left, to wash in them: such things as they offered for the burnt offering they washed in them; but the sea was for the priests to wash in.",
        },
        {
          verse: "7",
          text: "And he made ten candlesticks of gold according to their form, and set them in the temple, five on the right hand, and five on the left.",
        },
        {
          verse: "8",
          text: "He made also ten tables, and placed them in the temple, five on the right side, and five on the left. And he made an hundred basons of gold.",
        },
        {
          verse: "9",
          text: "Furthermore he made the court of the priests, and the great court, and doors for the court, and overlaid the doors of them with brass.",
        },
        {
          verse: "10",
          text: "And he set the sea on the right side of the east end, over against the south.",
        },
        {
          verse: "11",
          text: "And Huram made the pots, and the shovels, and the basons. And Huram finished the work that he was to make for king Solomon for the house of God;",
        },
        {
          verse: "12",
          text: "To wit, the two pillars, and the pommels, and the chapiters which were on the top of the two pillars, and the two wreaths to cover the two pommels of the chapiters which were on the top of the pillars;",
        },
        {
          verse: "13",
          text: "And four hundred pomegranates on the two wreaths; two rows of pomegranates on each wreath, to cover the two pommels of the chapiters which were upon the pillars.",
        },
        {
          verse: "14",
          text: "He made also bases, and lavers made he upon the bases;",
        },
        { verse: "15", text: "One sea, and twelve oxen under it." },
        {
          verse: "16",
          text: "The pots also, and the shovels, and the fleshhooks, and all their instruments, did Huram his father make to king Solomon for the house of the LORD of bright brass.",
        },
        {
          verse: "17",
          text: "In the plain of Jordan did the king cast them, in the clay ground between Succoth and Zeredathah.",
        },
        {
          verse: "18",
          text: "Thus Solomon made all these vessels in great abundance: for the weight of the brass could not be found out.",
        },
        {
          verse: "19",
          text: "And Solomon made all the vessels that were for the house of God, the golden altar also, and the tables whereon the shewbread was set;",
        },
        {
          verse: "20",
          text: "Moreover the candlesticks with their lamps, that they should burn after the manner before the oracle, of pure gold;",
        },
        {
          verse: "21",
          text: "And the flowers, and the lamps, and the tongs, made he of gold, and that perfect gold;",
        },
        {
          verse: "22",
          text: "And the snuffers, and the basons, and the spoons, and the censers, of pure gold: and the entry of the house, the inner doors thereof for the most holy place, and the doors of the house of the temple, were of gold.",
        },
      ],
    },
    {
      chapter: "5",
      verses: [
        {
          verse: "1",
          text: "Thus all the work that Solomon made for the house of the LORD was finished: and Solomon brought in all the things that David his father had dedicated; and the silver, and the gold, and all the instruments, put he among the treasures of the house of God.",
        },
        {
          verse: "2",
          text: "Then Solomon assembled the elders of Israel, and all the heads of the tribes, the chief of the fathers of the children of Israel, unto Jerusalem, to bring up the ark of the covenant of the LORD out of the city of David, which is Zion.",
        },
        {
          verse: "3",
          text: "Wherefore all the men of Israel assembled themselves unto the king in the feast which was in the seventh month.",
        },
        {
          verse: "4",
          text: "And all the elders of Israel came; and the Levites took up the ark.",
        },
        {
          verse: "5",
          text: "And they brought up the ark, and the tabernacle of the congregation, and all the holy vessels that were in the tabernacle, these did the priests and the Levites bring up.",
        },
        {
          verse: "6",
          text: "Also king Solomon, and all the congregation of Israel that were assembled unto him before the ark, sacrificed sheep and oxen, which could not be told nor numbered for multitude.",
        },
        {
          verse: "7",
          text: "And the priests brought in the ark of the covenant of the LORD unto his place, to the oracle of the house, into the most holy place, even under the wings of the cherubims:",
        },
        {
          verse: "8",
          text: "For the cherubims spread forth their wings over the place of the ark, and the cherubims covered the ark and the staves thereof above.",
        },
        {
          verse: "9",
          text: "And they drew out the staves of the ark, that the ends of the staves were seen from the ark before the oracle; but they were not seen without. And there it is unto this day.",
        },
        {
          verse: "10",
          text: "There was nothing in the ark save the two tables which Moses put therein at Horeb, when the LORD made a covenant with the children of Israel, when they came out of Egypt.",
        },
        {
          verse: "11",
          text: "And it came to pass, when the priests were come out of the holy place: (for all the priests that were present were sanctified, and did not then wait by course:",
        },
        {
          verse: "12",
          text: "Also the Levites which were the singers, all of them of Asaph, of Heman, of Jeduthun, with their sons and their brethren, being arrayed in white linen, having cymbals and psalteries and harps, stood at the east end of the altar, and with them an hundred and twenty priests sounding with trumpets:)",
        },
        {
          verse: "13",
          text: "It came even to pass, as the trumpeters and singers were as one, to make one sound to be heard in praising and thanking the LORD; and when they lifted up their voice with the trumpets and cymbals and instruments of musick, and praised the LORD, saying, For he is good; for his mercy endureth for ever: that then the house was filled with a cloud, even the house of the LORD;",
        },
        {
          verse: "14",
          text: "So that the priests could not stand to minister by reason of the cloud: for the glory of the LORD had filled the house of God.",
        },
      ],
    },
    {
      chapter: "6",
      verses: [
        {
          verse: "1",
          text: "Then said Solomon, The LORD hath said that he would dwell in the thick darkness.",
        },
        {
          verse: "2",
          text: "But I have built an house of habitation for thee, and a place for thy dwelling for ever.",
        },
        {
          verse: "3",
          text: "And the king turned his face, and blessed the whole congregation of Israel: and all the congregation of Israel stood.",
        },
        {
          verse: "4",
          text: "And he said, Blessed be the LORD God of Israel, who hath with his hands fulfilled that which he spake with his mouth to my father David, saying,",
        },
        {
          verse: "5",
          text: "Since the day that I brought forth my people out of the land of Egypt I chose no city among all the tribes of Israel to build an house in, that my name might be there; neither chose I any man to be a ruler over my people Israel:",
        },
        {
          verse: "6",
          text: "But I have chosen Jerusalem, that my name might be there; and have chosen David to be over my people Israel.",
        },
        {
          verse: "7",
          text: "Now it was in the heart of David my father to build an house for the name of the LORD God of Israel.",
        },
        {
          verse: "8",
          text: "But the LORD said to David my father, Forasmuch as it was in thine heart to build an house for my name, thou didst well in that it was in thine heart:",
        },
        {
          verse: "9",
          text: "Notwithstanding thou shalt not build the house; but thy son which shall come forth out of thy loins, he shall build the house for my name.",
        },
        {
          verse: "10",
          text: "The LORD therefore hath performed his word that he hath spoken: for I am risen up in the room of David my father, and am set on the throne of Israel, as the LORD promised, and have built the house for the name of the LORD God of Israel.",
        },
        {
          verse: "11",
          text: "And in it have I put the ark, wherein is the covenant of the LORD, that he made with the children of Israel.",
        },
        {
          verse: "12",
          text: "And he stood before the altar of the LORD in the presence of all the congregation of Israel, and spread forth his hands:",
        },
        {
          verse: "13",
          text: "For Solomon had made a brasen scaffold of five cubits long, and five cubits broad, and three cubits high, and had set it in the midst of the court: and upon it he stood, and kneeled down upon his knees before all the congregation of Israel, and spread forth his hands toward heaven,",
        },
        {
          verse: "14",
          text: "And said, O LORD God of Israel, there is no God like thee in the heaven, nor in the earth; which keepest covenant, and shewest mercy unto thy servants, that walk before thee with all their hearts:",
        },
        {
          verse: "15",
          text: "Thou which hast kept with thy servant David my father that which thou hast promised him; and spakest with thy mouth, and hast fulfilled it with thine hand, as it is this day.",
        },
        {
          verse: "16",
          text: "Now therefore, O LORD God of Israel, keep with thy servant David my father that which thou hast promised him, saying, There shall not fail thee a man in my sight to sit upon the throne of Israel; yet so that thy children take heed to their way to walk in my law, as thou hast walked before me.",
        },
        {
          verse: "17",
          text: "Now then, O LORD God of Israel, let thy word be verified, which thou hast spoken unto thy servant David.",
        },
        {
          verse: "18",
          text: "But will God in very deed dwell with men on the earth? behold, heaven and the heaven of heavens cannot contain thee; how much less this house which I have built!",
        },
        {
          verse: "19",
          text: "Have respect therefore to the prayer of thy servant, and to his supplication, O LORD my God, to hearken unto the cry and the prayer which thy servant prayeth before thee:",
        },
        {
          verse: "20",
          text: "That thine eyes may be open upon this house day and night, upon the place whereof thou hast said that thou wouldest put thy name there; to hearken unto the prayer which thy servant prayeth toward this place.",
        },
        {
          verse: "21",
          text: "Hearken therefore unto the supplications of thy servant, and of thy people Israel, which they shall make toward this place: hear thou from thy dwelling place, even from heaven; and when thou hearest, forgive.",
        },
        {
          verse: "22",
          text: "If a man sin against his neighbour, and an oath be laid upon him to make him swear, and the oath come before thine altar in this house;",
        },
        {
          verse: "23",
          text: "Then hear thou from heaven, and do, and judge thy servants, by requiting the wicked, by recompensing his way upon his own head; and by justifying the righteous, by giving him according to his righteousness.",
        },
        {
          verse: "24",
          text: "And if thy people Israel be put to the worse before the enemy, because they have sinned against thee; and shall return and confess thy name, and pray and make supplication before thee in this house;",
        },
        {
          verse: "25",
          text: "Then hear thou from the heavens, and forgive the sin of thy people Israel, and bring them again unto the land which thou gavest to them and to their fathers.",
        },
        {
          verse: "26",
          text: "When the heaven is shut up, and there is no rain, because they have sinned against thee; yet if they pray toward this place, and confess thy name, and turn from their sin, when thou dost afflict them;",
        },
        {
          verse: "27",
          text: "Then hear thou from heaven, and forgive the sin of thy servants, and of thy people Israel, when thou hast taught them the good way, wherein they should walk; and send rain upon thy land, which thou hast given unto thy people for an inheritance.",
        },
        {
          verse: "28",
          text: "If there be dearth in the land, if there be pestilence, if there be blasting, or mildew, locusts, or caterpillers; if their enemies besiege them in the cities of their land; whatsoever sore or whatsoever sickness there be:",
        },
        {
          verse: "29",
          text: "Then what prayer or what supplication soever shall be made of any man, or of all thy people Israel, when every one shall know his own sore and his own grief, and shall spread forth his hands in this house:",
        },
        {
          verse: "30",
          text: "Then hear thou from heaven thy dwelling place, and forgive, and render unto every man according unto all his ways, whose heart thou knowest; (for thou only knowest the hearts of the children of men:)",
        },
        {
          verse: "31",
          text: "That they may fear thee, to walk in thy ways, so long as they live in the land which thou gavest unto our fathers.",
        },
        {
          verse: "32",
          text: "Moreover concerning the stranger, which is not of thy people Israel, but is come from a far country for thy great name\u2019s sake, and thy mighty hand, and thy stretched out arm; if they come and pray in this house;",
        },
        {
          verse: "33",
          text: "Then hear thou from the heavens, even from thy dwelling place, and do according to all that the stranger calleth to thee for; that all people of the earth may know thy name, and fear thee, as doth thy people Israel, and may know that this house which I have built is called by thy name.",
        },
        {
          verse: "34",
          text: "If thy people go out to war against their enemies by the way that thou shalt send them, and they pray unto thee toward this city which thou hast chosen, and the house which I have built for thy name;",
        },
        {
          verse: "35",
          text: "Then hear thou from the heavens their prayer and their supplication, and maintain their cause.",
        },
        {
          verse: "36",
          text: "If they sin against thee, (for there is no man which sinneth not,) and thou be angry with them, and deliver them over before their enemies, and they carry them away captives unto a land far off or near;",
        },
        {
          verse: "37",
          text: "Yet if they bethink themselves in the land whither they are carried captive, and turn and pray unto thee in the land of their captivity, saying, We have sinned, we have done amiss, and have dealt wickedly;",
        },
        {
          verse: "38",
          text: "If they return to thee with all their heart and with all their soul in the land of their captivity, whither they have carried them captives, and pray toward their land, which thou gavest unto their fathers, and toward the city which thou hast chosen, and toward the house which I have built for thy name:",
        },
        {
          verse: "39",
          text: "Then hear thou from the heavens, even from thy dwelling place, their prayer and their supplications, and maintain their cause, and forgive thy people which have sinned against thee.",
        },
        {
          verse: "40",
          text: "Now, my God, let, I beseech thee, thine eyes be open, and let thine ears be attent unto the prayer that is made in this place.",
        },
        {
          verse: "41",
          text: "Now therefore arise, O LORD God, into thy resting place, thou, and the ark of thy strength: let thy priests, O LORD God, be clothed with salvation, and let thy saints rejoice in goodness.",
        },
        {
          verse: "42",
          text: "O LORD God, turn not away the face of thine anointed: remember the mercies of David thy servant.",
        },
      ],
    },
    {
      chapter: "7",
      verses: [
        {
          verse: "1",
          text: "Now when Solomon had made an end of praying, the fire came down from heaven, and consumed the burnt offering and the sacrifices; and the glory of the LORD filled the house.",
        },
        {
          verse: "2",
          text: "And the priests could not enter into the house of the LORD, because the glory of the LORD had filled the LORD\u2019s house.",
        },
        {
          verse: "3",
          text: "And when all the children of Israel saw how the fire came down, and the glory of the LORD upon the house, they bowed themselves with their faces to the ground upon the pavement, and worshipped, and praised the LORD, saying, For he is good; for his mercy endureth for ever.",
        },
        {
          verse: "4",
          text: "Then the king and all the people offered sacrifices before the LORD.",
        },
        {
          verse: "5",
          text: "And king Solomon offered a sacrifice of twenty and two thousand oxen, and an hundred and twenty thousand sheep: so the king and all the people dedicated the house of God.",
        },
        {
          verse: "6",
          text: "And the priests waited on their offices: the Levites also with instruments of musick of the LORD, which David the king had made to praise the LORD, because his mercy endureth for ever, when David praised by their ministry; and the priests sounded trumpets before them, and all Israel stood.",
        },
        {
          verse: "7",
          text: "Moreover Solomon hallowed the middle of the court that was before the house of the LORD: for there he offered burnt offerings, and the fat of the peace offerings, because the brasen altar which Solomon had made was not able to receive the burnt offerings, and the meat offerings, and the fat.",
        },
        {
          verse: "8",
          text: "Also at the same time Solomon kept the feast seven days, and all Israel with him, a very great congregation, from the entering in of Hamath unto the river of Egypt.",
        },
        {
          verse: "9",
          text: "And in the eighth day they made a solemn assembly: for they kept the dedication of the altar seven days, and the feast seven days.",
        },
        {
          verse: "10",
          text: "And on the three and twentieth day of the seventh month he sent the people away into their tents, glad and merry in heart for the goodness that the LORD had shewed unto David, and to Solomon, and to Israel his people.",
        },
        {
          verse: "11",
          text: "Thus Solomon finished the house of the LORD, and the king\u2019s house: and all that came into Solomon\u2019s heart to make in the house of the LORD, and in his own house, he prosperously effected.",
        },
        {
          verse: "12",
          text: "And the LORD appeared to Solomon by night, and said unto him, I have heard thy prayer, and have chosen this place to myself for an house of sacrifice.",
        },
        {
          verse: "13",
          text: "If I shut up heaven that there be no rain, or if I command the locusts to devour the land, or if I send pestilence among my people;",
        },
        {
          verse: "14",
          text: "If my people, which are called by my name, shall humble themselves, and pray, and seek my face, and turn from their wicked ways; then will I hear from heaven, and will forgive their sin, and will heal their land.",
        },
        {
          verse: "15",
          text: "Now mine eyes shall be open, and mine ears attent unto the prayer that is made in this place.",
        },
        {
          verse: "16",
          text: "For now have I chosen and sanctified this house, that my name may be there for ever: and mine eyes and mine heart shall be there perpetually.",
        },
        {
          verse: "17",
          text: "And as for thee, if thou wilt walk before me, as David thy father walked, and do according to all that I have commanded thee, and shalt observe my statutes and my judgments;",
        },
        {
          verse: "18",
          text: "Then will I stablish the throne of thy kingdom, according as I have covenanted with David thy father, saying, There shall not fail thee a man to be ruler in Israel.",
        },
        {
          verse: "19",
          text: "But if ye turn away, and forsake my statutes and my commandments, which I have set before you, and shall go and serve other gods, and worship them;",
        },
        {
          verse: "20",
          text: "Then will I pluck them up by the roots out of my land which I have given them; and this house, which I have sanctified for my name, will I cast out of my sight, and will make it to be a proverb and a byword among all nations.",
        },
        {
          verse: "21",
          text: "And this house, which is high, shall be an astonishment to every one that passeth by it; so that he shall say, Why hath the LORD done thus unto this land, and unto this house?",
        },
        {
          verse: "22",
          text: "And it shall be answered, Because they forsook the LORD God of their fathers, which brought them forth out of the land of Egypt, and laid hold on other gods, and worshipped them, and served them: therefore hath he brought all this evil upon them.",
        },
      ],
    },
    {
      chapter: "8",
      verses: [
        {
          verse: "1",
          text: "And it came to pass at the end of twenty years, wherein Solomon had built the house of the LORD, and his own house,",
        },
        {
          verse: "2",
          text: "That the cities which Huram had restored to Solomon, Solomon built them, and caused the children of Israel to dwell there.",
        },
        {
          verse: "3",
          text: "And Solomon went to Hamathzobah, and prevailed against it.",
        },
        {
          verse: "4",
          text: "And he built Tadmor in the wilderness, and all the store cities, which he built in Hamath.",
        },
        {
          verse: "5",
          text: "Also he built Bethhoron the upper, and Bethhoron the nether, fenced cities, with walls, gates, and bars;",
        },
        {
          verse: "6",
          text: "And Baalath, and all the store cities that Solomon had, and all the chariot cities, and the cities of the horsemen, and all that Solomon desired to build in Jerusalem, and in Lebanon, and throughout all the land of his dominion.",
        },
        {
          verse: "7",
          text: "As for all the people that were left of the Hittites, and the Amorites, and the Perizzites, and the Hivites, and the Jebusites, which were not of Israel,",
        },
        {
          verse: "8",
          text: "But of their children, who were left after them in the land, whom the children of Israel consumed not, them did Solomon make to pay tribute until this day.",
        },
        {
          verse: "9",
          text: "But of the children of Israel did Solomon make no servants for his work; but they were men of war, and chief of his captains, and captains of his chariots and horsemen.",
        },
        {
          verse: "10",
          text: "And these were the chief of king Solomon\u2019s officers, even two hundred and fifty, that bare rule over the people.",
        },
        {
          verse: "11",
          text: "And Solomon brought up the daughter of Pharaoh out of the city of David unto the house that he had built for her: for he said, My wife shall not dwell in the house of David king of Israel, because the places are holy, whereunto the ark of the LORD hath come.",
        },
        {
          verse: "12",
          text: "Then Solomon offered burnt offerings unto the LORD on the altar of the LORD, which he had built before the porch,",
        },
        {
          verse: "13",
          text: "Even after a certain rate every day, offering according to the commandment of Moses, on the sabbaths, and on the new moons, and on the solemn feasts, three times in the year, even in the feast of unleavened bread, and in the feast of weeks, and in the feast of tabernacles.",
        },
        {
          verse: "14",
          text: "And he appointed, according to the order of David his father, the courses of the priests to their service, and the Levites to their charges, to praise and minister before the priests, as the duty of every day required: the porters also by their courses at every gate: for so had David the man of God commanded.",
        },
        {
          verse: "15",
          text: "And they departed not from the commandment of the king unto the priests and Levites concerning any matter, or concerning the treasures.",
        },
        {
          verse: "16",
          text: "Now all the work of Solomon was prepared unto the day of the foundation of the house of the LORD, and until it was finished. So the house of the LORD was perfected.",
        },
        {
          verse: "17",
          text: "Then went Solomon to Eziongeber, and to Eloth, at the sea side in the land of Edom.",
        },
        {
          verse: "18",
          text: "And Huram sent him by the hands of his servants ships, and servants that had knowledge of the sea; and they went with the servants of Solomon to Ophir, and took thence four hundred and fifty talents of gold, and brought them to king Solomon.",
        },
      ],
    },
    {
      chapter: "9",
      verses: [
        {
          verse: "1",
          text: "And when the queen of Sheba heard of the fame of Solomon, she came to prove Solomon with hard questions at Jerusalem, with a very great company, and camels that bare spices, and gold in abundance, and precious stones: and when she was come to Solomon, she communed with him of all that was in her heart.",
        },
        {
          verse: "2",
          text: "And Solomon told her all her questions: and there was nothing hid from Solomon which he told her not.",
        },
        {
          verse: "3",
          text: "And when the queen of Sheba had seen the wisdom of Solomon, and the house that he had built,",
        },
        {
          verse: "4",
          text: "And the meat of his table, and the sitting of his servants, and the attendance of his ministers, and their apparel; his cupbearers also, and their apparel; and his ascent by which he went up into the house of the LORD; there was no more spirit in her.",
        },
        {
          verse: "5",
          text: "And she said to the king, It was a true report which I heard in mine own land of thine acts, and of thy wisdom:",
        },
        {
          verse: "6",
          text: "Howbeit I believed not their words, until I came, and mine eyes had seen it: and, behold, the one half of the greatness of thy wisdom was not told me: for thou exceedest the fame that I heard.",
        },
        {
          verse: "7",
          text: "Happy are thy men, and happy are these thy servants, which stand continually before thee, and hear thy wisdom.",
        },
        {
          verse: "8",
          text: "Blessed be the LORD thy God, which delighted in thee to set thee on his throne, to be king for the LORD thy God: because thy God loved Israel, to establish them for ever, therefore made he thee king over them, to do judgment and justice.",
        },
        {
          verse: "9",
          text: "And she gave the king an hundred and twenty talents of gold, and of spices great abundance, and precious stones: neither was there any such spice as the queen of Sheba gave king Solomon.",
        },
        {
          verse: "10",
          text: "And the servants also of Huram, and the servants of Solomon, which brought gold from Ophir, brought algum trees and precious stones.",
        },
        {
          verse: "11",
          text: "And the king made of the algum trees terraces to the house of the LORD, and to the king\u2019s palace, and harps and psalteries for singers: and there were none such seen before in the land of Judah.",
        },
        {
          verse: "12",
          text: "And king Solomon gave to the queen of Sheba all her desire, whatsoever she asked, beside that which she had brought unto the king. So she turned, and went away to her own land, she and her servants.",
        },
        {
          verse: "13",
          text: "Now the weight of gold that came to Solomon in one year was six hundred and threescore and six talents of gold;",
        },
        {
          verse: "14",
          text: "Beside that which chapmen and merchants brought. And all the kings of Arabia and governors of the country brought gold and silver to Solomon.",
        },
        {
          verse: "15",
          text: "And king Solomon made two hundred targets of beaten gold: six hundred shekels of beaten gold went to one target.",
        },
        {
          verse: "16",
          text: "And three hundred shields made he of beaten gold: three hundred shekels of gold went to one shield. And the king put them in the house of the forest of Lebanon.",
        },
        {
          verse: "17",
          text: "Moreover the king made a great throne of ivory, and overlaid it with pure gold.",
        },
        {
          verse: "18",
          text: "And there were six steps to the throne, with a footstool of gold, which were fastened to the throne, and stays on each side of the sitting place, and two lions standing by the stays:",
        },
        {
          verse: "19",
          text: "And twelve lions stood there on the one side and on the other upon the six steps. There was not the like made in any kingdom.",
        },
        {
          verse: "20",
          text: "And all the drinking vessels of king Solomon were of gold, and all the vessels of the house of the forest of Lebanon were of pure gold: none were of silver; it was not any thing accounted of in the days of Solomon.",
        },
        {
          verse: "21",
          text: "For the king\u2019s ships went to Tarshish with the servants of Huram: every three years once came the ships of Tarshish bringing gold, and silver, ivory, and apes, and peacocks.",
        },
        {
          verse: "22",
          text: "And king Solomon passed all the kings of the earth in riches and wisdom.",
        },
        {
          verse: "23",
          text: "And all the kings of the earth sought the presence of Solomon, to hear his wisdom, that God had put in his heart.",
        },
        {
          verse: "24",
          text: "And they brought every man his present, vessels of silver, and vessels of gold, and raiment, harness, and spices, horses, and mules, a rate year by year.",
        },
        {
          verse: "25",
          text: "And Solomon had four thousand stalls for horses and chariots, and twelve thousand horsemen; whom he bestowed in the chariot cities, and with the king at Jerusalem.",
        },
        {
          verse: "26",
          text: "And he reigned over all the kings from the river even unto the land of the Philistines, and to the border of Egypt.",
        },
        {
          verse: "27",
          text: "And the king made silver in Jerusalem as stones, and cedar trees made he as the sycomore trees that are in the low plains in abundance.",
        },
        {
          verse: "28",
          text: "And they brought unto Solomon horses out of Egypt, and out of all lands.",
        },
        {
          verse: "29",
          text: "Now the rest of the acts of Solomon, first and last, are they not written in the book of Nathan the prophet, and in the prophecy of Ahijah the Shilonite, and in the visions of Iddo the seer against Jeroboam the son of Nebat?",
        },
        {
          verse: "30",
          text: "And Solomon reigned in Jerusalem over all Israel forty years.",
        },
        {
          verse: "31",
          text: "And Solomon slept with his fathers, and he was buried in the city of David his father: and Rehoboam his son reigned in his stead.",
        },
      ],
    },
    {
      chapter: "10",
      verses: [
        {
          verse: "1",
          text: "And Rehoboam went to Shechem: for to Shechem were all Israel come to make him king.",
        },
        {
          verse: "2",
          text: "And it came to pass, when Jeroboam the son of Nebat, who was in Egypt, whither he had fled from the presence of Solomon the king, heard it, that Jeroboam returned out of Egypt.",
        },
        {
          verse: "3",
          text: "And they sent and called him. So Jeroboam and all Israel came and spake to Rehoboam, saying,",
        },
        {
          verse: "4",
          text: "Thy father made our yoke grievous: now therefore ease thou somewhat the grievous servitude of thy father, and his heavy yoke that he put upon us, and we will serve thee.",
        },
        {
          verse: "5",
          text: "And he said unto them, Come again unto me after three days. And the people departed.",
        },
        {
          verse: "6",
          text: "And king Rehoboam took counsel with the old men that had stood before Solomon his father while he yet lived, saying, What counsel give ye me to return answer to this people?",
        },
        {
          verse: "7",
          text: "And they spake unto him, saying, If thou be kind to this people, and please them, and speak good words to them, they will be thy servants for ever.",
        },
        {
          verse: "8",
          text: "But he forsook the counsel which the old men gave him, and took counsel with the young men that were brought up with him, that stood before him.",
        },
        {
          verse: "9",
          text: "And he said unto them, What advice give ye that we may return answer to this people, which have spoken to me, saying, Ease somewhat the yoke that thy father did put upon us?",
        },
        {
          verse: "10",
          text: "And the young men that were brought up with him spake unto him, saying, Thus shalt thou answer the people that spake unto thee, saying, Thy father made our yoke heavy, but make thou it somewhat lighter for us; thus shalt thou say unto them, My little finger shall be thicker than my father\u2019s loins.",
        },
        {
          verse: "11",
          text: "For whereas my father put a heavy yoke upon you, I will put more to your yoke: my father chastised you with whips, but I will chastise you with scorpions.",
        },
        {
          verse: "12",
          text: "So Jeroboam and all the people came to Rehoboam on the third day, as the king bade, saying, Come again to me on the third day.",
        },
        {
          verse: "13",
          text: "And the king answered them roughly; and king Rehoboam forsook the counsel of the old men,",
        },
        {
          verse: "14",
          text: "And answered them after the advice of the young men, saying, My father made your yoke heavy, but I will add thereto: my father chastised you with whips, but I will chastise you with scorpions.",
        },
        {
          verse: "15",
          text: "So the king hearkened not unto the people: for the cause was of God, that the LORD might perform his word, which he spake by the hand of Ahijah the Shilonite to Jeroboam the son of Nebat.",
        },
        {
          verse: "16",
          text: "And when all Israel saw that the king would not hearken unto them, the people answered the king, saying, What portion have we in David? and we have none inheritance in the son of Jesse: every man to your tents, O Israel: and now, David, see to thine own house. So all Israel went to their tents.",
        },
        {
          verse: "17",
          text: "But as for the children of Israel that dwelt in the cities of Judah, Rehoboam reigned over them.",
        },
        {
          verse: "18",
          text: "Then king Rehoboam sent Hadoram that was over the tribute; and the children of Israel stoned him with stones, that he died. But king Rehoboam made speed to get him up to his chariot, to flee to Jerusalem.",
        },
        {
          verse: "19",
          text: "And Israel rebelled against the house of David unto this day.",
        },
      ],
    },
    {
      chapter: "11",
      verses: [
        {
          verse: "1",
          text: "And when Rehoboam was come to Jerusalem, he gathered of the house of Judah and Benjamin an hundred and fourscore thousand chosen men, which were warriors, to fight against Israel, that he might bring the kingdom again to Rehoboam.",
        },
        {
          verse: "2",
          text: "But the word of the LORD came to Shemaiah the man of God, saying,",
        },
        {
          verse: "3",
          text: "Speak unto Rehoboam the son of Solomon, king of Judah, and to all Israel in Judah and Benjamin, saying,",
        },
        {
          verse: "4",
          text: "Thus saith the LORD, Ye shall not go up, nor fight against your brethren: return every man to his house: for this thing is done of me. And they obeyed the words of the LORD, and returned from going against Jeroboam.",
        },
        {
          verse: "5",
          text: "And Rehoboam dwelt in Jerusalem, and built cities for defence in Judah.",
        },
        { verse: "6", text: "He built even Bethlehem, and Etam, and Tekoa," },
        { verse: "7", text: "And Bethzur, and Shoco, and Adullam," },
        { verse: "8", text: "And Gath, and Mareshah, and Ziph," },
        { verse: "9", text: "And Adoraim, and Lachish, and Azekah," },
        {
          verse: "10",
          text: "And Zorah, and Aijalon, and Hebron, which are in Judah and in Benjamin fenced cities.",
        },
        {
          verse: "11",
          text: "And he fortified the strong holds, and put captains in them, and store of victual, and of oil and wine.",
        },
        {
          verse: "12",
          text: "And in every several city he put shields and spears, and made them exceeding strong, having Judah and Benjamin on his side.",
        },
        {
          verse: "13",
          text: "And the priests and the Levites that were in all Israel resorted to him out of all their coasts.",
        },
        {
          verse: "14",
          text: "For the Levites left their suburbs and their possession, and came to Judah and Jerusalem: for Jeroboam and his sons had cast them off from executing the priest\u2019s office unto the LORD:",
        },
        {
          verse: "15",
          text: "And he ordained him priests for the high places, and for the devils, and for the calves which he had made.",
        },
        {
          verse: "16",
          text: "And after them out of all the tribes of Israel such as set their hearts to seek the LORD God of Israel came to Jerusalem, to sacrifice unto the LORD God of their fathers.",
        },
        {
          verse: "17",
          text: "So they strengthened the kingdom of Judah, and made Rehoboam the son of Solomon strong, three years: for three years they walked in the way of David and Solomon.",
        },
        {
          verse: "18",
          text: "And Rehoboam took him Mahalath the daughter of Jerimoth the son of David to wife, and Abihail the daughter of Eliab the son of Jesse;",
        },
        {
          verse: "19",
          text: "Which bare him children; Jeush, and Shamariah, and Zaham.",
        },
        {
          verse: "20",
          text: "And after her he took Maachah the daughter of Absalom; which bare him Abijah, and Attai, and Ziza, and Shelomith.",
        },
        {
          verse: "21",
          text: "And Rehoboam loved Maachah the daughter of Absalom above all his wives and his concubines: (for he took eighteen wives, and threescore concubines; and begat twenty and eight sons, and threescore daughters.)",
        },
        {
          verse: "22",
          text: "And Rehoboam made Abijah the son of Maachah the chief, to be ruler among his brethren: for he thought to make him king.",
        },
        {
          verse: "23",
          text: "And he dealt wisely, and dispersed of all his children throughout all the countries of Judah and Benjamin, unto every fenced city: and he gave them victual in abundance. And he desired many wives.",
        },
      ],
    },
    {
      chapter: "12",
      verses: [
        {
          verse: "1",
          text: "And it came to pass, when Rehoboam had established the kingdom, and had strengthened himself, he forsook the law of the LORD, and all Israel with him.",
        },
        {
          verse: "2",
          text: "And it came to pass, that in the fifth year of king Rehoboam Shishak king of Egypt came up against Jerusalem, because they had transgressed against the LORD,",
        },
        {
          verse: "3",
          text: "With twelve hundred chariots, and threescore thousand horsemen: and the people were without number that came with him out of Egypt; the Lubims, the Sukkiims, and the Ethiopians.",
        },
        {
          verse: "4",
          text: "And he took the fenced cities which pertained to Judah, and came to Jerusalem.",
        },
        {
          verse: "5",
          text: "Then came Shemaiah the prophet to Rehoboam, and to the princes of Judah, that were gathered together to Jerusalem because of Shishak, and said unto them, Thus saith the LORD, Ye have forsaken me, and therefore have I also left you in the hand of Shishak.",
        },
        {
          verse: "6",
          text: "Whereupon the princes of Israel and the king humbled themselves; and they said, The LORD is righteous.",
        },
        {
          verse: "7",
          text: "And when the LORD saw that they humbled themselves, the word of the LORD came to Shemaiah, saying, They have humbled themselves; therefore I will not destroy them, but I will grant them some deliverance; and my wrath shall not be poured out upon Jerusalem by the hand of Shishak.",
        },
        {
          verse: "8",
          text: "Nevertheless they shall be his servants; that they may know my service, and the service of the kingdoms of the countries.",
        },
        {
          verse: "9",
          text: "So Shishak king of Egypt came up against Jerusalem, and took away the treasures of the house of the LORD, and the treasures of the king\u2019s house; he took all: he carried away also the shields of gold which Solomon had made.",
        },
        {
          verse: "10",
          text: "Instead of which king Rehoboam made shields of brass, and committed them to the hands of the chief of the guard, that kept the entrance of the king\u2019s house.",
        },
        {
          verse: "11",
          text: "And when the king entered into the house of the LORD, the guard came and fetched them, and brought them again into the guard chamber.",
        },
        {
          verse: "12",
          text: "And when he humbled himself, the wrath of the LORD turned from him, that he would not destroy him altogether: and also in Judah things went well.",
        },
        {
          verse: "13",
          text: "So king Rehoboam strengthened himself in Jerusalem, and reigned: for Rehoboam was one and forty years old when he began to reign, and he reigned seventeen years in Jerusalem, the city which the LORD had chosen out of all the tribes of Israel, to put his name there. And his mother\u2019s name was Naamah an Ammonitess.",
        },
        {
          verse: "14",
          text: "And he did evil, because he prepared not his heart to seek the LORD.",
        },
        {
          verse: "15",
          text: "Now the acts of Rehoboam, first and last, are they not written in the book of Shemaiah the prophet, and of Iddo the seer concerning genealogies? And there were wars between Rehoboam and Jeroboam continually.",
        },
        {
          verse: "16",
          text: "And Rehoboam slept with his fathers, and was buried in the city of David: and Abijah his son reigned in his stead.",
        },
      ],
    },
    {
      chapter: "13",
      verses: [
        {
          verse: "1",
          text: "Now in the eighteenth year of king Jeroboam began Abijah to reign over Judah.",
        },
        {
          verse: "2",
          text: "He reigned three years in Jerusalem. His mother\u2019s name also was Michaiah the daughter of Uriel of Gibeah. And there was war between Abijah and Jeroboam.",
        },
        {
          verse: "3",
          text: "And Abijah set the battle in array with an army of valiant men of war, even four hundred thousand chosen men: Jeroboam also set the battle in array against him with eight hundred thousand chosen men, being mighty men of valour.",
        },
        {
          verse: "4",
          text: "And Abijah stood up upon mount Zemaraim, which is in mount Ephraim, and said, Hear me, thou Jeroboam, and all Israel;",
        },
        {
          verse: "5",
          text: "Ought ye not to know that the LORD God of Israel gave the kingdom over Israel to David for ever, even to him and to his sons by a covenant of salt?",
        },
        {
          verse: "6",
          text: "Yet Jeroboam the son of Nebat, the servant of Solomon the son of David, is risen up, and hath rebelled against his lord.",
        },
        {
          verse: "7",
          text: "And there are gathered unto him vain men, the children of Belial, and have strengthened themselves against Rehoboam the son of Solomon, when Rehoboam was young and tenderhearted, and could not withstand them.",
        },
        {
          verse: "8",
          text: "And now ye think to withstand the kingdom of the LORD in the hand of the sons of David; and ye be a great multitude, and there are with you golden calves, which Jeroboam made you for gods.",
        },
        {
          verse: "9",
          text: "Have ye not cast out the priests of the LORD, the sons of Aaron, and the Levites, and have made you priests after the manner of the nations of other lands? so that whosoever cometh to consecrate himself with a young bullock and seven rams, the same may be a priest of them that are no gods.",
        },
        {
          verse: "10",
          text: "But as for us, the LORD is our God, and we have not forsaken him; and the priests, which minister unto the LORD, are the sons of Aaron, and the Levites wait upon their business:",
        },
        {
          verse: "11",
          text: "And they burn unto the LORD every morning and every evening burnt sacrifices and sweet incense: the shewbread also set they in order upon the pure table; and the candlestick of gold with the lamps thereof, to burn every evening: for we keep the charge of the LORD our God; but ye have forsaken him.",
        },
        {
          verse: "12",
          text: "And, behold, God himself is with us for our captain, and his priests with sounding trumpets to cry alarm against you. O children of Israel, fight ye not against the LORD God of your fathers; for ye shall not prosper.",
        },
        {
          verse: "13",
          text: "But Jeroboam caused an ambushment to come about behind them: so they were before Judah, and the ambushment was behind them.",
        },
        {
          verse: "14",
          text: "And when Judah looked back, behold, the battle was before and behind: and they cried unto the LORD, and the priests sounded with the trumpets.",
        },
        {
          verse: "15",
          text: "Then the men of Judah gave a shout: and as the men of Judah shouted, it came to pass, that God smote Jeroboam and all Israel before Abijah and Judah.",
        },
        {
          verse: "16",
          text: "And the children of Israel fled before Judah: and God delivered them into their hand.",
        },
        {
          verse: "17",
          text: "And Abijah and his people slew them with a great slaughter: so there fell down slain of Israel five hundred thousand chosen men.",
        },
        {
          verse: "18",
          text: "Thus the children of Israel were brought under at that time, and the children of Judah prevailed, because they relied upon the LORD God of their fathers.",
        },
        {
          verse: "19",
          text: "And Abijah pursued after Jeroboam, and took cities from him, Bethel with the towns thereof, and Jeshanah with the towns thereof, and Ephrain with the towns thereof.",
        },
        {
          verse: "20",
          text: "Neither did Jeroboam recover strength again in the days of Abijah: and the LORD struck him, and he died.",
        },
        {
          verse: "21",
          text: "But Abijah waxed mighty, and married fourteen wives, and begat twenty and two sons, and sixteen daughters.",
        },
        {
          verse: "22",
          text: "And the rest of the acts of Abijah, and his ways, and his sayings, are written in the story of the prophet Iddo.",
        },
      ],
    },
    {
      chapter: "14",
      verses: [
        {
          verse: "1",
          text: "So Abijah slept with his fathers, and they buried him in the city of David: and Asa his son reigned in his stead. In his days the land was quiet ten years.",
        },
        {
          verse: "2",
          text: "And Asa did that which was good and right in the eyes of the LORD his God:",
        },
        {
          verse: "3",
          text: "For he took away the altars of the strange gods, and the high places, and brake down the images, and cut down the groves:",
        },
        {
          verse: "4",
          text: "And commanded Judah to seek the LORD God of their fathers, and to do the law and the commandment.",
        },
        {
          verse: "5",
          text: "Also he took away out of all the cities of Judah the high places and the images: and the kingdom was quiet before him.",
        },
        {
          verse: "6",
          text: "And he built fenced cities in Judah: for the land had rest, and he had no war in those years; because the LORD had given him rest.",
        },
        {
          verse: "7",
          text: "Therefore he said unto Judah, Let us build these cities, and make about them walls, and towers, gates, and bars, while the land is yet before us; because we have sought the LORD our God, we have sought him, and he hath given us rest on every side. So they built and prospered.",
        },
        {
          verse: "8",
          text: "And Asa had an army of men that bare targets and spears, out of Judah three hundred thousand; and out of Benjamin, that bare shields and drew bows, two hundred and fourscore thousand: all these were mighty men of valour.",
        },
        {
          verse: "9",
          text: "And there came out against them Zerah the Ethiopian with an host of a thousand thousand, and three hundred chariots; and came unto Mareshah.",
        },
        {
          verse: "10",
          text: "Then Asa went out against him, and they set the battle in array in the valley of Zephathah at Mareshah.",
        },
        {
          verse: "11",
          text: "And Asa cried unto the LORD his God, and said, LORD, it is nothing with thee to help, whether with many, or with them that have no power: help us, O LORD our God; for we rest on thee, and in thy name we go against this multitude. O LORD, thou art our God; let not man prevail against thee.",
        },
        {
          verse: "12",
          text: "So the LORD smote the Ethiopians before Asa, and before Judah; and the Ethiopians fled.",
        },
        {
          verse: "13",
          text: "And Asa and the people that were with him pursued them unto Gerar: and the Ethiopians were overthrown, that they could not recover themselves; for they were destroyed before the LORD, and before his host; and they carried away very much spoil.",
        },
        {
          verse: "14",
          text: "And they smote all the cities round about Gerar; for the fear of the LORD came upon them: and they spoiled all the cities; for there was exceeding much spoil in them.",
        },
        {
          verse: "15",
          text: "They smote also the tents of cattle, and carried away sheep and camels in abundance, and returned to Jerusalem.",
        },
      ],
    },
    {
      chapter: "15",
      verses: [
        {
          verse: "1",
          text: "And the Spirit of God came upon Azariah the son of Oded:",
        },
        {
          verse: "2",
          text: "And he went out to meet Asa, and said unto him, Hear ye me, Asa, and all Judah and Benjamin; The LORD is with you, while ye be with him; and if ye seek him, he will be found of you; but if ye forsake him, he will forsake you.",
        },
        {
          verse: "3",
          text: "Now for a long season Israel hath been without the true God, and without a teaching priest, and without law.",
        },
        {
          verse: "4",
          text: "But when they in their trouble did turn unto the LORD God of Israel, and sought him, he was found of them.",
        },
        {
          verse: "5",
          text: "And in those times there was no peace to him that went out, nor to him that came in, but great vexations were upon all the inhabitants of the countries.",
        },
        {
          verse: "6",
          text: "And nation was destroyed of nation, and city of city: for God did vex them with all adversity.",
        },
        {
          verse: "7",
          text: "Be ye strong therefore, and let not your hands be weak: for your work shall be rewarded.",
        },
        {
          verse: "8",
          text: "And when Asa heard these words, and the prophecy of Oded the prophet, he took courage, and put away the abominable idols out of all the land of Judah and Benjamin, and out of the cities which he had taken from mount Ephraim, and renewed the altar of the LORD, that was before the porch of the LORD.",
        },
        {
          verse: "9",
          text: "And he gathered all Judah and Benjamin, and the strangers with them out of Ephraim and Manasseh, and out of Simeon: for they fell to him out of Israel in abundance, when they saw that the LORD his God was with him.",
        },
        {
          verse: "10",
          text: "So they gathered themselves together at Jerusalem in the third month, in the fifteenth year of the reign of Asa.",
        },
        {
          verse: "11",
          text: "And they offered unto the LORD the same time, of the spoil which they had brought, seven hundred oxen and seven thousand sheep.",
        },
        {
          verse: "12",
          text: "And they entered into a covenant to seek the LORD God of their fathers with all their heart and with all their soul;",
        },
        {
          verse: "13",
          text: "That whosoever would not seek the LORD God of Israel should be put to death, whether small or great, whether man or woman.",
        },
        {
          verse: "14",
          text: "And they sware unto the LORD with a loud voice, and with shouting, and with trumpets, and with cornets.",
        },
        {
          verse: "15",
          text: "And all Judah rejoiced at the oath: for they had sworn with all their heart, and sought him with their whole desire; and he was found of them: and the LORD gave them rest round about.",
        },
        {
          verse: "16",
          text: "And also concerning Maachah the mother of Asa the king, he removed her from being queen, because she had made an idol in a grove: and Asa cut down her idol, and stamped it, and burnt it at the brook Kidron.",
        },
        {
          verse: "17",
          text: "But the high places were not taken away out of Israel: nevertheless the heart of Asa was perfect all his days.",
        },
        {
          verse: "18",
          text: "And he brought into the house of God the things that his father had dedicated, and that he himself had dedicated, silver, and gold, and vessels.",
        },
        {
          verse: "19",
          text: "And there was no more war unto the five and thirtieth year of the reign of Asa.",
        },
      ],
    },
    {
      chapter: "16",
      verses: [
        {
          verse: "1",
          text: "In the six and thirtieth year of the reign of Asa Baasha king of Israel came up against Judah, and built Ramah, to the intent that he might let none go out or come in to Asa king of Judah.",
        },
        {
          verse: "2",
          text: "Then Asa brought out silver and gold out of the treasures of the house of the LORD and of the king\u2019s house, and sent to Benhadad king of Syria, that dwelt at Damascus, saying,",
        },
        {
          verse: "3",
          text: "There is a league between me and thee, as there was between my father and thy father: behold, I have sent thee silver and gold; go, break thy league with Baasha king of Israel, that he may depart from me.",
        },
        {
          verse: "4",
          text: "And Benhadad hearkened unto king Asa, and sent the captains of his armies against the cities of Israel; and they smote Ijon, and Dan, and Abelmaim, and all the store cities of Naphtali.",
        },
        {
          verse: "5",
          text: "And it came to pass, when Baasha heard it, that he left off building of Ramah, and let his work cease.",
        },
        {
          verse: "6",
          text: "Then Asa the king took all Judah; and they carried away the stones of Ramah, and the timber thereof, wherewith Baasha was building; and he built therewith Geba and Mizpah.",
        },
        {
          verse: "7",
          text: "And at that time Hanani the seer came to Asa king of Judah, and said unto him, Because thou hast relied on the king of Syria, and not relied on the LORD thy God, therefore is the host of the king of Syria escaped out of thine hand.",
        },
        {
          verse: "8",
          text: "Were not the Ethiopians and the Lubims a huge host, with very many chariots and horsemen? yet, because thou didst rely on the LORD, he delivered them into thine hand.",
        },
        {
          verse: "9",
          text: "For the eyes of the LORD run to and fro throughout the whole earth, to shew himself strong in the behalf of them whose heart is perfect toward him. Herein thou hast done foolishly: therefore from henceforth thou shalt have wars.",
        },
        {
          verse: "10",
          text: "Then Asa was wroth with the seer, and put him in a prison house; for he was in a rage with him because of this thing. And Asa oppressed some of the people the same time.",
        },
        {
          verse: "11",
          text: "And, behold, the acts of Asa, first and last, lo, they are written in the book of the kings of Judah and Israel.",
        },
        {
          verse: "12",
          text: "And Asa in the thirty and ninth year of his reign was diseased in his feet, until his disease was exceeding great: yet in his disease he sought not to the LORD, but to the physicians.",
        },
        {
          verse: "13",
          text: "And Asa slept with his fathers, and died in the one and fortieth year of his reign.",
        },
        {
          verse: "14",
          text: "And they buried him in his own sepulchres, which he had made for himself in the city of David, and laid him in the bed which was filled with sweet odours and divers kinds of spices prepared by the apothecaries\u2019 art: and they made a very great burning for him.",
        },
      ],
    },
    {
      chapter: "17",
      verses: [
        {
          verse: "1",
          text: "And Jehoshaphat his son reigned in his stead, and strengthened himself against Israel.",
        },
        {
          verse: "2",
          text: "And he placed forces in all the fenced cities of Judah, and set garrisons in the land of Judah, and in the cities of Ephraim, which Asa his father had taken.",
        },
        {
          verse: "3",
          text: "And the LORD was with Jehoshaphat, because he walked in the first ways of his father David, and sought not unto Baalim;",
        },
        {
          verse: "4",
          text: "But sought to the Lord God of his father, and walked in his commandments, and not after the doings of Israel.",
        },
        {
          verse: "5",
          text: "Therefore the LORD stablished the kingdom in his hand; and all Judah brought to Jehoshaphat presents; and he had riches and honour in abundance.",
        },
        {
          verse: "6",
          text: "And his heart was lifted up in the ways of the LORD: moreover he took away the high places and groves out of Judah.",
        },
        {
          verse: "7",
          text: "Also in the third year of his reign he sent to his princes, even to Benhail, and to Obadiah, and to Zechariah, and to Nethaneel, and to Michaiah, to teach in the cities of Judah.",
        },
        {
          verse: "8",
          text: "And with them he sent Levites, even Shemaiah, and Nethaniah, and Zebadiah, and Asahel, and Shemiramoth, and Jehonathan, and Adonijah, and Tobijah, and Tobadonijah, Levites; and with them Elishama and Jehoram, priests.",
        },
        {
          verse: "9",
          text: "And they taught in Judah, and had the book of the law of the LORD with them, and went about throughout all the cities of Judah, and taught the people.",
        },
        {
          verse: "10",
          text: "And the fear of the LORD fell upon all the kingdoms of the lands that were round about Judah, so that they made no war against Jehoshaphat.",
        },
        {
          verse: "11",
          text: "Also some of the Philistines brought Jehoshaphat presents, and tribute silver; and the Arabians brought him flocks, seven thousand and seven hundred rams, and seven thousand and seven hundred he goats.",
        },
        {
          verse: "12",
          text: "And Jehoshaphat waxed great exceedingly; and he built in Judah castles, and cities of store.",
        },
        {
          verse: "13",
          text: "And he had much business in the cities of Judah: and the men of war, mighty men of valour, were in Jerusalem.",
        },
        {
          verse: "14",
          text: "And these are the numbers of them according to the house of their fathers: Of Judah, the captains of thousands; Adnah the chief, and with him mighty men of valour three hundred thousand.",
        },
        {
          verse: "15",
          text: "And next to him was Jehohanan the captain, and with him two hundred and fourscore thousand.",
        },
        {
          verse: "16",
          text: "And next him was Amasiah the son of Zichri, who willingly offered himself unto the LORD; and with him two hundred thousand mighty men of valour.",
        },
        {
          verse: "17",
          text: "And of Benjamin; Eliada a mighty man of valour, and with him armed men with bow and shield two hundred thousand.",
        },
        {
          verse: "18",
          text: "And next him was Jehozabad, and with him an hundred and fourscore thousand ready prepared for the war.",
        },
        {
          verse: "19",
          text: "These waited on the king, beside those whom the king put in the fenced cities throughout all Judah.",
        },
      ],
    },
    {
      chapter: "18",
      verses: [
        {
          verse: "1",
          text: "Now Jehoshaphat had riches and honour in abundance, and joined affinity with Ahab.",
        },
        {
          verse: "2",
          text: "And after certain years he went down to Ahab to Samaria. And Ahab killed sheep and oxen for him in abundance, and for the people that he had with him, and persuaded him to go up with him to Ramothgilead.",
        },
        {
          verse: "3",
          text: "And Ahab king of Israel said unto Jehoshaphat king of Judah, Wilt thou go with me to Ramothgilead? And he answered him, I am as thou art, and my people as thy people; and we will be with thee in the war.",
        },
        {
          verse: "4",
          text: "And Jehoshaphat said unto the king of Israel, Enquire, I pray thee, at the word of the LORD to day.",
        },
        {
          verse: "5",
          text: "Therefore the king of Israel gathered together of prophets four hundred men, and said unto them, Shall we go to Ramothgilead to battle, or shall I forbear? And they said, Go up; for God will deliver it into the king\u2019s hand.",
        },
        {
          verse: "6",
          text: "But Jehoshaphat said, Is there not here a prophet of the LORD besides, that we might enquire of him?",
        },
        {
          verse: "7",
          text: "And the king of Israel said unto Jehoshaphat, There is yet one man, by whom we may enquire of the LORD: but I hate him; for he never prophesied good unto me, but always evil: the same is Micaiah the son of Imla. And Jehoshaphat said, Let not the king say so.",
        },
        {
          verse: "8",
          text: "And the king of Israel called for one of his officers, and said, Fetch quickly Micaiah the son of Imla.",
        },
        {
          verse: "9",
          text: "And the king of Israel and Jehoshaphat king of Judah sat either of them on his throne, clothed in their robes, and they sat in a void place at the entering in of the gate of Samaria; and all the prophets prophesied before them.",
        },
        {
          verse: "10",
          text: "And Zedekiah the son of Chenaanah had made him horns of iron, and said, Thus saith the LORD, With these thou shalt push Syria until they be consumed.",
        },
        {
          verse: "11",
          text: "And all the prophets prophesied so, saying, Go up to Ramothgilead, and prosper: for the LORD shall deliver it into the hand of the king.",
        },
        {
          verse: "12",
          text: "And the messenger that went to call Micaiah spake to him, saying, Behold, the words of the prophets declare good to the king with one assent; let thy word therefore, I pray thee, be like one of theirs, and speak thou good.",
        },
        {
          verse: "13",
          text: "And Micaiah said, As the LORD liveth, even what my God saith, that will I speak.",
        },
        {
          verse: "14",
          text: "And when he was come to the king, the king said unto him, Micaiah, shall we go to Ramothgilead to battle, or shall I forbear? And he said, Go ye up, and prosper, and they shall be delivered into your hand.",
        },
        {
          verse: "15",
          text: "And the king said to him, How many times shall I adjure thee that thou say nothing but the truth to me in the name of the LORD?",
        },
        {
          verse: "16",
          text: "Then he said, I did see all Israel scattered upon the mountains, as sheep that have no shepherd: and the LORD said, These have no master; let them return therefore every man to his house in peace.",
        },
        {
          verse: "17",
          text: "And the king of Israel said to Jehoshaphat, Did I not tell thee that he would not prophesy good unto me, but evil?",
        },
        {
          verse: "18",
          text: "Again he said, Therefore hear the word of the LORD; I saw the LORD sitting upon his throne, and all the host of heaven standing on his right hand and on his left.",
        },
        {
          verse: "19",
          text: "And the LORD said, Who shall entice Ahab king of Israel, that he may go up and fall at Ramothgilead? And one spake saying after this manner, and another saying after that manner.",
        },
        {
          verse: "20",
          text: "Then there came out a spirit, and stood before the LORD, and said, I will entice him. And the LORD said unto him, Wherewith?",
        },
        {
          verse: "21",
          text: "And he said, I will go out, and be a lying spirit in the mouth of all his prophets. And the Lord said, Thou shalt entice him, and thou shalt also prevail: go out, and do even so.",
        },
        {
          verse: "22",
          text: "Now therefore, behold, the LORD hath put a lying spirit in the mouth of these thy prophets, and the LORD hath spoken evil against thee.",
        },
        {
          verse: "23",
          text: "Then Zedekiah the son of Chenaanah came near, and smote Micaiah upon the cheek, and said, Which way went the Spirit of the LORD from me to speak unto thee?",
        },
        {
          verse: "24",
          text: "And Micaiah said, Behold, thou shalt see on that day when thou shalt go into an inner chamber to hide thyself.",
        },
        {
          verse: "25",
          text: "Then the king of Israel said, Take ye Micaiah, and carry him back to Amon the governor of the city, and to Joash the king\u2019s son;",
        },
        {
          verse: "26",
          text: "And say, Thus saith the king, Put this fellow in the prison, and feed him with bread of affliction and with water of affliction, until I return in peace.",
        },
        {
          verse: "27",
          text: "And Micaiah said, If thou certainly return in peace, then hath not the LORD spoken by me. And he said, Hearken, all ye people.",
        },
        {
          verse: "28",
          text: "So the king of Israel and Jehoshaphat the king of Judah went up to Ramothgilead.",
        },
        {
          verse: "29",
          text: "And the king of Israel said unto Jehoshaphat, I will disguise myself, and will go to the battle; but put thou on thy robes. So the king of Israel disguised himself; and they went to the battle.",
        },
        {
          verse: "30",
          text: "Now the king of Syria had commanded the captains of the chariots that were with him, saying, Fight ye not with small or great, save only with the king of Israel.",
        },
        {
          verse: "31",
          text: "And it came to pass, when the captains of the chariots saw Jehoshaphat, that they said, It is the king of Israel. Therefore they compassed about him to fight: but Jehoshaphat cried out, and the LORD helped him; and God moved them to depart from him.",
        },
        {
          verse: "32",
          text: "For it came to pass, that, when the captains of the chariots perceived that it was not the king of Israel, they turned back again from pursuing him.",
        },
        {
          verse: "33",
          text: "And a certain man drew a bow at a venture, and smote the king of Israel between the joints of the harness: therefore he said to his chariot man, Turn thine hand, that thou mayest carry me out of the host; for I am wounded.",
        },
        {
          verse: "34",
          text: "And the battle increased that day: howbeit the king of Israel stayed himself up in his chariot against the Syrians until the even: and about the time of the sun going down he died.",
        },
      ],
    },
    {
      chapter: "19",
      verses: [
        {
          verse: "1",
          text: "And Jehoshaphat the king of Judah returned to his house in peace to Jerusalem.",
        },
        {
          verse: "2",
          text: "And Jehu the son of Hanani the seer went out to meet him, and said to king Jehoshaphat, Shouldest thou help the ungodly, and love them that hate the LORD? therefore is wrath upon thee from before the LORD.",
        },
        {
          verse: "3",
          text: "Nevertheless there are good things found in thee, in that thou hast taken away the groves out of the land, and hast prepared thine heart to seek God.",
        },
        {
          verse: "4",
          text: "And Jehoshaphat dwelt at Jerusalem: and he went out again through the people from Beersheba to mount Ephraim, and brought them back unto the LORD God of their fathers.",
        },
        {
          verse: "5",
          text: "And he set judges in the land throughout all the fenced cities of Judah, city by city,",
        },
        {
          verse: "6",
          text: "And said to the judges, Take heed what ye do: for ye judge not for man, but for the LORD, who is with you in the judgment.",
        },
        {
          verse: "7",
          text: "Wherefore now let the fear of the LORD be upon you; take heed and do it: for there is no iniquity with the LORD our God, nor respect of persons, nor taking of gifts.",
        },
        {
          verse: "8",
          text: "Moreover in Jerusalem did Jehoshaphat set of the Levites, and of the priests, and of the chief of the fathers of Israel, for the judgment of the LORD, and for controversies, when they returned to Jerusalem.",
        },
        {
          verse: "9",
          text: "And he charged them, saying, Thus shall ye do in the fear of the LORD, faithfully, and with a perfect heart.",
        },
        {
          verse: "10",
          text: "And what cause soever shall come to you of your brethren that dwell in their cities, between blood and blood, between law and commandment, statutes and judgments, ye shall even warn them that they trespass not against the LORD, and so wrath come upon you, and upon your brethren: this do, and ye shall not trespass.",
        },
        {
          verse: "11",
          text: "And, behold, Amariah the chief priest is over you in all matters of the LORD; and Zebadiah the son of Ishmael, the ruler of the house of Judah, for all the king\u2019s matters: also the Levites shall be officers before you. Deal courageously, and the LORD shall be with the good.",
        },
      ],
    },
    {
      chapter: "20",
      verses: [
        {
          verse: "1",
          text: "It came to pass after this also, that the children of Moab, and the children of Ammon, and with them other beside the Ammonites, came against Jehoshaphat to battle.",
        },
        {
          verse: "2",
          text: "Then there came some that told Jehoshaphat, saying, There cometh a great multitude against thee from beyond the sea on this side Syria; and, behold, they be in Hazazontamar, which is Engedi.",
        },
        {
          verse: "3",
          text: "And Jehoshaphat feared, and set himself to seek the LORD, and proclaimed a fast throughout all Judah.",
        },
        {
          verse: "4",
          text: "And Judah gathered themselves together, to ask help of the LORD: even out of all the cities of Judah they came to seek the LORD.",
        },
        {
          verse: "5",
          text: "And Jehoshaphat stood in the congregation of Judah and Jerusalem, in the house of the LORD, before the new court,",
        },
        {
          verse: "6",
          text: "And said, O LORD God of our fathers, art not thou God in heaven? and rulest not thou over all the kingdoms of the heathen? and in thine hand is there not power and might, so that none is able to withstand thee?",
        },
        {
          verse: "7",
          text: "Art not thou our God, who didst drive out the inhabitants of this land before thy people Israel, and gavest it to the seed of Abraham thy friend for ever?",
        },
        {
          verse: "8",
          text: "And they dwelt therein, and have built thee a sanctuary therein for thy name, saying,",
        },
        {
          verse: "9",
          text: "If, when evil cometh upon us, as the sword, judgment, or pestilence, or famine, we stand before this house, and in thy presence, (for thy name is in this house,) and cry unto thee in our affliction, then thou wilt hear and help.",
        },
        {
          verse: "10",
          text: "And now, behold, the children of Ammon and Moab and mount Seir, whom thou wouldest not let Israel invade, when they came out of the land of Egypt, but they turned from them, and destroyed them not;",
        },
        {
          verse: "11",
          text: "Behold, I say, how they reward us, to come to cast us out of thy possession, which thou hast given us to inherit.",
        },
        {
          verse: "12",
          text: "O our God, wilt thou not judge them? for we have no might against this great company that cometh against us; neither know we what to do: but our eyes are upon thee.",
        },
        {
          verse: "13",
          text: "And all Judah stood before the LORD, with their little ones, their wives, and their children.",
        },
        {
          verse: "14",
          text: "Then upon Jahaziel the son of Zechariah, the son of Benaiah, the son of Jeiel, the son of Mattaniah, a Levite of the sons of Asaph, came the Spirit of the LORD in the midst of the congregation;",
        },
        {
          verse: "15",
          text: "And he said, Hearken ye, all Judah, and ye inhabitants of Jerusalem, and thou king Jehoshaphat, Thus saith the LORD unto you, Be not afraid nor dismayed by reason of this great multitude; for the battle is not yours, but God\u2019s.",
        },
        {
          verse: "16",
          text: "To morrow go ye down against them: behold, they come up by the cliff of Ziz; and ye shall find them at the end of the brook, before the wilderness of Jeruel.",
        },
        {
          verse: "17",
          text: "Ye shall not need to fight in this battle: set yourselves, stand ye still, and see the salvation of the LORD with you, O Judah and Jerusalem: fear not, nor be dismayed; to morrow go out against them: for the LORD will be with you.",
        },
        {
          verse: "18",
          text: "And Jehoshaphat bowed his head with his face to the ground: and all Judah and the inhabitants of Jerusalem fell before the LORD, worshipping the LORD.",
        },
        {
          verse: "19",
          text: "And the Levites, of the children of the Kohathites, and of the children of the Korhites, stood up to praise the LORD God of Israel with a loud voice on high.",
        },
        {
          verse: "20",
          text: "And they rose early in the morning, and went forth into the wilderness of Tekoa: and as they went forth, Jehoshaphat stood and said, Hear me, O Judah, and ye inhabitants of Jerusalem; Believe in the LORD your God, so shall ye be established; believe his prophets, so shall ye prosper.",
        },
        {
          verse: "21",
          text: "And when he had consulted with the people, he appointed singers unto the LORD, and that should praise the beauty of holiness, as they went out before the army, and to say, Praise the LORD; for his mercy endureth for ever.",
        },
        {
          verse: "22",
          text: "And when they began to sing and to praise, the LORD set ambushments against the children of Ammon, Moab, and mount Seir, which were come against Judah; and they were smitten.",
        },
        {
          verse: "23",
          text: "For the children of Ammon and Moab stood up against the inhabitants of mount Seir, utterly to slay and destroy them: and when they had made an end of the inhabitants of Seir, every one helped to destroy another.",
        },
        {
          verse: "24",
          text: "And when Judah came toward the watch tower in the wilderness, they looked unto the multitude, and, behold, they were dead bodies fallen to the earth, and none escaped.",
        },
        {
          verse: "25",
          text: "And when Jehoshaphat and his people came to take away the spoil of them, they found among them in abundance both riches with the dead bodies, and precious jewels, which they stripped off for themselves, more than they could carry away: and they were three days in gathering of the spoil, it was so much.",
        },
        {
          verse: "26",
          text: "And on the fourth day they assembled themselves in the valley of Berachah; for there they blessed the LORD: therefore the name of the same place was called, The valley of Berachah, unto this day.",
        },
        {
          verse: "27",
          text: "Then they returned, every man of Judah and Jerusalem, and Jehoshaphat in the forefront of them, to go again to Jerusalem with joy; for the LORD had made them to rejoice over their enemies.",
        },
        {
          verse: "28",
          text: "And they came to Jerusalem with psalteries and harps and trumpets unto the house of the LORD.",
        },
        {
          verse: "29",
          text: "And the fear of God was on all the kingdoms of those countries, when they had heard that the LORD fought against the enemies of Israel.",
        },
        {
          verse: "30",
          text: "So the realm of Jehoshaphat was quiet: for his God gave him rest round about.",
        },
        {
          verse: "31",
          text: "And Jehoshaphat reigned over Judah: he was thirty and five years old when he began to reign, and he reigned twenty and five years in Jerusalem. And his mother\u2019s name was Azubah the daughter of Shilhi.",
        },
        {
          verse: "32",
          text: "And he walked in the way of Asa his father, and departed not from it, doing that which was right in the sight of the LORD.",
        },
        {
          verse: "33",
          text: "Howbeit the high places were not taken away: for as yet the people had not prepared their hearts unto the God of their fathers.",
        },
        {
          verse: "34",
          text: "Now the rest of the acts of Jehoshaphat, first and last, behold, they are written in the book of Jehu the son of Hanani, who is mentioned in the book of the kings of Israel.",
        },
        {
          verse: "35",
          text: "And after this did Jehoshaphat king of Judah join himself with Ahaziah king of Israel, who did very wickedly:",
        },
        {
          verse: "36",
          text: "And he joined himself with him to make ships to go to Tarshish: and they made the ships in Eziongaber.",
        },
        {
          verse: "37",
          text: "Then Eliezer the son of Dodavah of Mareshah prophesied against Jehoshaphat, saying, Because thou hast joined thyself with Ahaziah, the LORD hath broken thy works. And the ships were broken, that they were not able to go to Tarshish.",
        },
      ],
    },
    {
      chapter: "21",
      verses: [
        {
          verse: "1",
          text: "Now Jehoshaphat slept with his fathers, and was buried with his fathers in the city of David. And Jehoram his son reigned in his stead.",
        },
        {
          verse: "2",
          text: "And he had brethren the sons of Jehoshaphat, Azariah, and Jehiel, and Zechariah, and Azariah, and Michael, and Shephatiah: all these were the sons of Jehoshaphat king of Israel.",
        },
        {
          verse: "3",
          text: "And their father gave them great gifts of silver, and of gold, and of precious things, with fenced cities in Judah: but the kingdom gave he to Jehoram; because he was the firstborn.",
        },
        {
          verse: "4",
          text: "Now when Jehoram was risen up to the kingdom of his father, he strengthened himself, and slew all his brethren with the sword, and divers also of the princes of Israel.",
        },
        {
          verse: "5",
          text: "Jehoram was thirty and two years old when he began to reign, and he reigned eight years in Jerusalem.",
        },
        {
          verse: "6",
          text: "And he walked in the way of the kings of Israel, like as did the house of Ahab: for he had the daughter of Ahab to wife: and he wrought that which was evil in the eyes of the LORD.",
        },
        {
          verse: "7",
          text: "Howbeit the LORD would not destroy the house of David, because of the covenant that he had made with David, and as he promised to give a light to him and to his sons for ever.",
        },
        {
          verse: "8",
          text: "In his days the Edomites revolted from under the dominion of Judah, and made themselves a king.",
        },
        {
          verse: "9",
          text: "Then Jehoram went forth with his princes, and all his chariots with him: and he rose up by night, and smote the Edomites which compassed him in, and the captains of the chariots.",
        },
        {
          verse: "10",
          text: "So the Edomites revolted from under the hand of Judah unto this day. The same time also did Libnah revolt from under his hand; because he had forsaken the LORD God of his fathers.",
        },
        {
          verse: "11",
          text: "Moreover he made high places in the mountains of Judah, and caused the inhabitants of Jerusalem to commit fornication, and compelled Judah thereto.",
        },
        {
          verse: "12",
          text: "And there came a writing to him from Elijah the prophet, saying, Thus saith the LORD God of David thy father, Because thou hast not walked in the ways of Jehoshaphat thy father, nor in the ways of Asa king of Judah,",
        },
        {
          verse: "13",
          text: "But hast walked in the way of the kings of Israel, and hast made Judah and the inhabitants of Jerusalem to go a whoring, like to the whoredoms of the house of Ahab, and also hast slain thy brethren of thy father\u2019s house, which were better than thyself:",
        },
        {
          verse: "14",
          text: "Behold, with a great plague will the LORD smite thy people, and thy children, and thy wives, and all thy goods:",
        },
        {
          verse: "15",
          text: "And thou shalt have great sickness by disease of thy bowels, until thy bowels fall out by reason of the sickness day by day.",
        },
        {
          verse: "16",
          text: "Moreover the LORD stirred up against Jehoram the spirit of the Philistines, and of the Arabians, that were near the Ethiopians:",
        },
        {
          verse: "17",
          text: "And they came up into Judah, and brake into it, and carried away all the substance that was found in the king\u2019s house, and his sons also, and his wives; so that there was never a son left him, save Jehoahaz, the youngest of his sons.",
        },
        {
          verse: "18",
          text: "And after all this the LORD smote him in his bowels with an incurable disease.",
        },
        {
          verse: "19",
          text: "And it came to pass, that in process of time, after the end of two years, his bowels fell out by reason of his sickness: so he died of sore diseases. And his people made no burning for him, like the burning of his fathers.",
        },
        {
          verse: "20",
          text: "Thirty and two years old was he when he began to reign, and he reigned in Jerusalem eight years, and departed without being desired. Howbeit they buried him in the city of David, but not in the sepulchres of the kings.",
        },
      ],
    },
    {
      chapter: "22",
      verses: [
        {
          verse: "1",
          text: "And the inhabitants of Jerusalem made Ahaziah his youngest son king in his stead: for the band of men that came with the Arabians to the camp had slain all the eldest. So Ahaziah the son of Jehoram king of Judah reigned.",
        },
        {
          verse: "2",
          text: "Forty and two years old was Ahaziah when he began to reign, and he reigned one year in Jerusalem. His mother\u2019s name also was Athaliah the daughter of Omri.",
        },
        {
          verse: "3",
          text: "He also walked in the ways of the house of Ahab: for his mother was his counsellor to do wickedly.",
        },
        {
          verse: "4",
          text: "Wherefore he did evil in the sight of the LORD like the house of Ahab: for they were his counsellors after the death of his father to his destruction.",
        },
        {
          verse: "5",
          text: "He walked also after their counsel, and went with Jehoram the son of Ahab king of Israel to war against Hazael king of Syria at Ramothgilead: and the Syrians smote Joram.",
        },
        {
          verse: "6",
          text: "And he returned to be healed in Jezreel because of the wounds which were given him at Ramah, when he fought with Hazael king of Syria. And Azariah the son of Jehoram king of Judah went down to see Jehoram the son of Ahab at Jezreel, because he was sick.",
        },
        {
          verse: "7",
          text: "And the destruction of Ahaziah was of God by coming to Joram: for when he was come, he went out with Jehoram against Jehu the son of Nimshi, whom the LORD had anointed to cut off the house of Ahab.",
        },
        {
          verse: "8",
          text: "And it came to pass, that, when Jehu was executing judgment upon the house of Ahab, and found the princes of Judah, and the sons of the brethren of Ahaziah, that ministered to Ahaziah, he slew them.",
        },
        {
          verse: "9",
          text: "And he sought Ahaziah: and they caught him, (for he was hid in Samaria,) and brought him to Jehu: and when they had slain him, they buried him: Because, said they, he is the son of Jehoshaphat, who sought the LORD with all his heart. So the house of Ahaziah had no power to keep still the kingdom.",
        },
        {
          verse: "10",
          text: "But when Athaliah the mother of Ahaziah saw that her son was dead, she arose and destroyed all the seed royal of the house of Judah.",
        },
        {
          verse: "11",
          text: "But Jehoshabeath, the daughter of the king, took Joash the son of Ahaziah, and stole him from among the king\u2019s sons that were slain, and put him and his nurse in a bedchamber. So Jehoshabeath, the daughter of king Jehoram, the wife of Jehoiada the priest, (for she was the sister of Ahaziah,) hid him from Athaliah, so that she slew him not.",
        },
        {
          verse: "12",
          text: "And he was with them hid in the house of God six years: and Athaliah reigned over the land.",
        },
      ],
    },
    {
      chapter: "23",
      verses: [
        {
          verse: "1",
          text: "And in the seventh year Jehoiada strengthened himself, and took the captains of hundreds, Azariah the son of Jeroham, and Ishmael the son of Jehohanan, and Azariah the son of Obed, and Maaseiah the son of Adaiah, and Elishaphat the son of Zichri, into covenant with him.",
        },
        {
          verse: "2",
          text: "And they went about in Judah, and gathered the Levites out of all the cities of Judah, and the chief of the fathers of Israel, and they came to Jerusalem.",
        },
        {
          verse: "3",
          text: "And all the congregation made a covenant with the king in the house of God. And he said unto them, Behold, the king\u2019s son shall reign, as the LORD hath said of the sons of David.",
        },
        {
          verse: "4",
          text: "This is the thing that ye shall do; A third part of you entering on the sabbath, of the priests and of the Levites, shall be porters of the doors;",
        },
        {
          verse: "5",
          text: "And a third part shall be at the king\u2019s house; and a third part at the gate of the foundation: and all the people shall be in the courts of the house of the LORD.",
        },
        {
          verse: "6",
          text: "But let none come into the house of the LORD, save the priests, and they that minister of the Levites; they shall go in, for they are holy: but all the people shall keep the watch of the LORD.",
        },
        {
          verse: "7",
          text: "And the Levites shall compass the king round about, every man with his weapons in his hand; and whosoever else cometh into the house, he shall be put to death: but be ye with the king when he cometh in, and when he goeth out.",
        },
        {
          verse: "8",
          text: "So the Levites and all Judah did according to all things that Jehoiada the priest had commanded, and took every man his men that were to come in on the sabbath, with them that were to go out on the sabbath: for Jehoiada the priest dismissed not the courses.",
        },
        {
          verse: "9",
          text: "Moreover Jehoiada the priest delivered to the captains of hundreds spears, and bucklers, and shields, that had been king David\u2019s, which were in the house of God.",
        },
        {
          verse: "10",
          text: "And he set all the people, every man having his weapon in his hand, from the right side of the temple to the left side of the temple, along by the altar and the temple, by the king round about.",
        },
        {
          verse: "11",
          text: "Then they brought out the king\u2019s son, and put upon him the crown, and gave him the testimony, and made him king. And Jehoiada and his sons anointed him, and said, God save the king.",
        },
        {
          verse: "12",
          text: "Now when Athaliah heard the noise of the people running and praising the king, she came to the people into the house of the LORD:",
        },
        {
          verse: "13",
          text: "And she looked, and, behold, the king stood at his pillar at the entering in, and the princes and the trumpets by the king: and all the people of the land rejoiced, and sounded with trumpets, also the singers with instruments of musick, and such as taught to sing praise. Then Athaliah rent her clothes, and said, Treason, Treason.",
        },
        {
          verse: "14",
          text: "Then Jehoiada the priest brought out the captains of hundreds that were set over the host, and said unto them, Have her forth of the ranges: and whoso followeth her, let him be slain with the sword. For the priest said, Slay her not in the house of the LORD.",
        },
        {
          verse: "15",
          text: "So they laid hands on her; and when she was come to the entering of the horse gate by the king\u2019s house, they slew her there.",
        },
        {
          verse: "16",
          text: "And Jehoiada made a covenant between him, and between all the people, and between the king, that they should be the LORD\u2019s people.",
        },
        {
          verse: "17",
          text: "Then all the people went to the house of Baal, and brake it down, and brake his altars and his images in pieces, and slew Mattan the priest of Baal before the altars.",
        },
        {
          verse: "18",
          text: "Also Jehoiada appointed the offices of the house of the LORD by the hand of the priests the Levites, whom David had distributed in the house of the LORD, to offer the burnt offerings of the LORD, as it is written in the law of Moses, with rejoicing and with singing, as it was ordained by David.",
        },
        {
          verse: "19",
          text: "And he set the porters at the gates of the house of the LORD, that none which was unclean in any thing should enter in.",
        },
        {
          verse: "20",
          text: "And he took the captains of hundreds, and the nobles, and the governors of the people, and all the people of the land, and brought down the king from the house of the LORD: and they came through the high gate into the king\u2019s house, and set the king upon the throne of the kingdom.",
        },
        {
          verse: "21",
          text: "And all the people of the land rejoiced: and the city was quiet, after that they had slain Athaliah with the sword.",
        },
      ],
    },
    {
      chapter: "24",
      verses: [
        {
          verse: "1",
          text: "Joash was seven years old when he began to reign, and he reigned forty years in Jerusalem. His mother\u2019s name also was Zibiah of Beersheba.",
        },
        {
          verse: "2",
          text: "And Joash did that which was right in the sight of the LORD all the days of Jehoiada the priest.",
        },
        {
          verse: "3",
          text: "And Jehoiada took for him two wives; and he begat sons and daughters.",
        },
        {
          verse: "4",
          text: "And it came to pass after this, that Joash was minded to repair the house of the LORD.",
        },
        {
          verse: "5",
          text: "And he gathered together the priests and the Levites, and said to them, Go out unto the cities of Judah, and gather of all Israel money to repair the house of your God from year to year, and see that ye hasten the matter. Howbeit the Levites hastened it not.",
        },
        {
          verse: "6",
          text: "And the king called for Jehoiada the chief, and said unto him, Why hast thou not required of the Levites to bring in out of Judah and out of Jerusalem the collection, according to the commandment of Moses the servant of the LORD, and of the congregation of Israel, for the tabernacle of witness?",
        },
        {
          verse: "7",
          text: "For the sons of Athaliah, that wicked woman, had broken up the house of God; and also all the dedicated things of the house of the LORD did they bestow upon Baalim.",
        },
        {
          verse: "8",
          text: "And at the king\u2019s commandment they made a chest, and set it without at the gate of the house of the LORD.",
        },
        {
          verse: "9",
          text: "And they made a proclamation through Judah and Jerusalem, to bring in to the LORD the collection that Moses the servant of God laid upon Israel in the wilderness.",
        },
        {
          verse: "10",
          text: "And all the princes and all the people rejoiced, and brought in, and cast into the chest, until they had made an end.",
        },
        {
          verse: "11",
          text: "Now it came to pass, that at what time the chest was brought unto the king\u2019s office by the hand of the Levites, and when they saw that there was much money, the king\u2019s scribe and the high priest\u2019s officer came and emptied the chest, and took it, and carried it to his place again. Thus they did day by day, and gathered money in abundance.",
        },
        {
          verse: "12",
          text: "And the king and Jehoiada gave it to such as did the work of the service of the house of the LORD, and hired masons and carpenters to repair the house of the LORD, and also such as wrought iron and brass to mend the house of the LORD.",
        },
        {
          verse: "13",
          text: "So the workmen wrought, and the work was perfected by them, and they set the house of God in his state, and strengthened it.",
        },
        {
          verse: "14",
          text: "And when they had finished it, they brought the rest of the money before the king and Jehoiada, whereof were made vessels for the house of the LORD, even vessels to minister, and to offer withal, and spoons, and vessels of gold and silver. And they offered burnt offerings in the house of the LORD continually all the days of Jehoiada.",
        },
        {
          verse: "15",
          text: "But Jehoiada waxed old, and was full of days when he died; an hundred and thirty years old was he when he died.",
        },
        {
          verse: "16",
          text: "And they buried him in the city of David among the kings, because he had done good in Israel, both toward God, and toward his house.",
        },
        {
          verse: "17",
          text: "Now after the death of Jehoiada came the princes of Judah, and made obeisance to the king. Then the king hearkened unto them.",
        },
        {
          verse: "18",
          text: "And they left the house of the LORD God of their fathers, and served groves and idols: and wrath came upon Judah and Jerusalem for this their trespass.",
        },
        {
          verse: "19",
          text: "Yet he sent prophets to them, to bring them again unto the LORD; and they testified against them: but they would not give ear.",
        },
        {
          verse: "20",
          text: "And the Spirit of God came upon Zechariah the son of Jehoiada the priest, which stood above the people, and said unto them, Thus saith God, Why transgress ye the commandments of the LORD, that ye cannot prosper? because ye have forsaken the LORD, he hath also forsaken you.",
        },
        {
          verse: "21",
          text: "And they conspired against him, and stoned him with stones at the commandment of the king in the court of the house of the LORD.",
        },
        {
          verse: "22",
          text: "Thus Joash the king remembered not the kindness which Jehoiada his father had done to him, but slew his son. And when he died, he said, The LORD look upon it, and require it.",
        },
        {
          verse: "23",
          text: "And it came to pass at the end of the year, that the host of Syria came up against him: and they came to Judah and Jerusalem, and destroyed all the princes of the people from among the people, and sent all the spoil of them unto the king of Damascus.",
        },
        {
          verse: "24",
          text: "For the army of the Syrians came with a small company of men, and the LORD delivered a very great host into their hand, because they had forsaken the LORD God of their fathers. So they executed judgment against Joash.",
        },
        {
          verse: "25",
          text: "And when they were departed from him, (for they left him in great diseases,) his own servants conspired against him for the blood of the sons of Jehoiada the priest, and slew him on his bed, and he died: and they buried him in the city of David, but they buried him not in the sepulchres of the kings.",
        },
        {
          verse: "26",
          text: "And these are they that conspired against him; Zabad the son of Shimeath an Ammonitess, and Jehozabad the son of Shimrith a Moabitess.",
        },
        {
          verse: "27",
          text: "Now concerning his sons, and the greatness of the burdens laid upon him, and the repairing of the house of God, behold, they are written in the story of the book of the kings. And Amaziah his son reigned in his stead.",
        },
      ],
    },
    {
      chapter: "25",
      verses: [
        {
          verse: "1",
          text: "Amaziah was twenty and five years old when he began to reign, and he reigned twenty and nine years in Jerusalem. And his mother\u2019s name was Jehoaddan of Jerusalem.",
        },
        {
          verse: "2",
          text: "And he did that which was right in the sight of the LORD, but not with a perfect heart.",
        },
        {
          verse: "3",
          text: "Now it came to pass, when the kingdom was established to him, that he slew his servants that had killed the king his father.",
        },
        {
          verse: "4",
          text: "But he slew not their children, but did as it is written in the law in the book of Moses, where the LORD commanded, saying, The fathers shall not die for the children, neither shall the children die for the fathers, but every man shall die for his own sin.",
        },
        {
          verse: "5",
          text: "Moreover Amaziah gathered Judah together, and made them captains over thousands, and captains over hundreds, according to the houses of their fathers, throughout all Judah and Benjamin: and he numbered them from twenty years old and above, and found them three hundred thousand choice men, able to go forth to war, that could handle spear and shield.",
        },
        {
          verse: "6",
          text: "He hired also an hundred thousand mighty men of valour out of Israel for an hundred talents of silver.",
        },
        {
          verse: "7",
          text: "But there came a man of God to him, saying, O king, let not the army of Israel go with thee; for the LORD is not with Israel, to wit, with all the children of Ephraim.",
        },
        {
          verse: "8",
          text: "But if thou wilt go, do it, be strong for the battle: God shall make thee fall before the enemy: for God hath power to help, and to cast down.",
        },
        {
          verse: "9",
          text: "And Amaziah said to the man of God, But what shall we do for the hundred talents which I have given to the army of Israel? And the man of God answered, The LORD is able to give thee much more than this.",
        },
        {
          verse: "10",
          text: "Then Amaziah separated them, to wit, the army that was come to him out of Ephraim, to go home again: wherefore their anger was greatly kindled against Judah, and they returned home in great anger.",
        },
        {
          verse: "11",
          text: "And Amaziah strengthened himself, and led forth his people, and went to the valley of salt, and smote of the children of Seir ten thousand.",
        },
        {
          verse: "12",
          text: "And other ten thousand left alive did the children of Judah carry away captive, and brought them unto the top of the rock, and cast them down from the top of the rock, that they all were broken in pieces.",
        },
        {
          verse: "13",
          text: "But the soldiers of the army which Amaziah sent back, that they should not go with him to battle, fell upon the cities of Judah, from Samaria even unto Bethhoron, and smote three thousand of them, and took much spoil.",
        },
        {
          verse: "14",
          text: "Now it came to pass, after that Amaziah was come from the slaughter of the Edomites, that he brought the gods of the children of Seir, and set them up to be his gods, and bowed down himself before them, and burned incense unto them.",
        },
        {
          verse: "15",
          text: "Wherefore the anger of the LORD was kindled against Amaziah, and he sent unto him a prophet, which said unto him, Why hast thou sought after the gods of the people, which could not deliver their own people out of thine hand?",
        },
        {
          verse: "16",
          text: "And it came to pass, as he talked with him, that the king said unto him, Art thou made of the king\u2019s counsel? forbear; why shouldest thou be smitten? Then the prophet forbare, and said, I know that God hath determined to destroy thee, because thou hast done this, and hast not hearkened unto my counsel.",
        },
        {
          verse: "17",
          text: "Then Amaziah king of Judah took advice, and sent to Joash, the son of Jehoahaz, the son of Jehu, king of Israel, saying, Come, let us see one another in the face.",
        },
        {
          verse: "18",
          text: "And Joash king of Israel sent to Amaziah king of Judah, saying, The thistle that was in Lebanon sent to the cedar that was in Lebanon, saying, Give thy daughter to my son to wife: and there passed by a wild beast that was in Lebanon, and trode down the thistle.",
        },
        {
          verse: "19",
          text: "Thou sayest, Lo, thou hast smitten the Edomites; and thine heart lifteth thee up to boast: abide now at home; why shouldest thou meddle to thine hurt, that thou shouldest fall, even thou, and Judah with thee?",
        },
        {
          verse: "20",
          text: "But Amaziah would not hear; for it came of God, that he might deliver them into the hand of their enemies, because they sought after the gods of Edom.",
        },
        {
          verse: "21",
          text: "So Joash the king of Israel went up; and they saw one another in the face, both he and Amaziah king of Judah, at Bethshemesh, which belongeth to Judah.",
        },
        {
          verse: "22",
          text: "And Judah was put to the worse before Israel, and they fled every man to his tent.",
        },
        {
          verse: "23",
          text: "And Joash the king of Israel took Amaziah king of Judah, the son of Joash, the son of Jehoahaz, at Bethshemesh, and brought him to Jerusalem, and brake down the wall of Jerusalem from the gate of Ephraim to the corner gate, four hundred cubits.",
        },
        {
          verse: "24",
          text: "And he took all the gold and the silver, and all the vessels that were found in the house of God with Obededom, and the treasures of the king\u2019s house, the hostages also, and returned to Samaria.",
        },
        {
          verse: "25",
          text: "And Amaziah the son of Joash king of Judah lived after the death of Joash son of Jehoahaz king of Israel fifteen years.",
        },
        {
          verse: "26",
          text: "Now the rest of the acts of Amaziah, first and last, behold, are they not written in the book of the kings of Judah and Israel?",
        },
        {
          verse: "27",
          text: "Now after the time that Amaziah did turn away from following the LORD they made a conspiracy against him in Jerusalem; and he fled to Lachish: but they sent to Lachish after him, and slew him there.",
        },
        {
          verse: "28",
          text: "And they brought him upon horses, and buried him with his fathers in the city of Judah.",
        },
      ],
    },
    {
      chapter: "26",
      verses: [
        {
          verse: "1",
          text: "Then all the people of Judah took Uzziah, who was sixteen years old, and made him king in the room of his father Amaziah.",
        },
        {
          verse: "2",
          text: "He built Eloth, and restored it to Judah, after that the king slept with his fathers.",
        },
        {
          verse: "3",
          text: "Sixteen years old was Uzziah when he began to reign, and he reigned fifty and two years in Jerusalem. His mother\u2019s name also was Jecoliah of Jerusalem.",
        },
        {
          verse: "4",
          text: "And he did that which was right in the sight of the LORD, according to all that his father Amaziah did.",
        },
        {
          verse: "5",
          text: "And he sought God in the days of Zechariah, who had understanding in the visions of God: and as long as he sought the LORD, God made him to prosper.",
        },
        {
          verse: "6",
          text: "And he went forth and warred against the Philistines, and brake down the wall of Gath, and the wall of Jabneh, and the wall of Ashdod, and built cities about Ashdod, and among the Philistines.",
        },
        {
          verse: "7",
          text: "And God helped him against the Philistines, and against the Arabians that dwelt in Gurbaal, and the Mehunims.",
        },
        {
          verse: "8",
          text: "And the Ammonites gave gifts to Uzziah: and his name spread abroad even to the entering in of Egypt; for he strengthened himself exceedingly.",
        },
        {
          verse: "9",
          text: "Moreover Uzziah built towers in Jerusalem at the corner gate, and at the valley gate, and at the turning of the wall, and fortified them.",
        },
        {
          verse: "10",
          text: "Also he built towers in the desert, and digged many wells: for he had much cattle, both in the low country, and in the plains: husbandmen also, and vine dressers in the mountains, and in Carmel: for he loved husbandry.",
        },
        {
          verse: "11",
          text: "Moreover Uzziah had an host of fighting men, that went out to war by bands, according to the number of their account by the hand of Jeiel the scribe and Maaseiah the ruler, under the hand of Hananiah, one of the king\u2019s captains.",
        },
        {
          verse: "12",
          text: "The whole number of the chief of the fathers of the mighty men of valour were two thousand and six hundred.",
        },
        {
          verse: "13",
          text: "And under their hand was an army, three hundred thousand and seven thousand and five hundred, that made war with mighty power, to help the king against the enemy.",
        },
        {
          verse: "14",
          text: "And Uzziah prepared for them throughout all the host shields, and spears, and helmets, and habergeons, and bows, and slings to cast stones.",
        },
        {
          verse: "15",
          text: "And he made in Jerusalem engines, invented by cunning men, to be on the towers and upon the bulwarks, to shoot arrows and great stones withal. And his name spread far abroad; for he was marvellously helped, till he was strong.",
        },
        {
          verse: "16",
          text: "But when he was strong, his heart was lifted up to his destruction: for he transgressed against the LORD his God, and went into the temple of the LORD to burn incense upon the altar of incense.",
        },
        {
          verse: "17",
          text: "And Azariah the priest went in after him, and with him fourscore priests of the LORD, that were valiant men:",
        },
        {
          verse: "18",
          text: "And they withstood Uzziah the king, and said unto him, It appertaineth not unto thee, Uzziah, to burn incense unto the LORD, but to the priests the sons of Aaron, that are consecrated to burn incense: go out of the sanctuary; for thou hast trespassed; neither shall it be for thine honour from the LORD God.",
        },
        {
          verse: "19",
          text: "Then Uzziah was wroth, and had a censer in his hand to burn incense: and while he was wroth with the priests, the leprosy even rose up in his forehead before the priests in the house of the LORD, from beside the incense altar.",
        },
        {
          verse: "20",
          text: "And Azariah the chief priest, and all the priests, looked upon him, and, behold, he was leprous in his forehead, and they thrust him out from thence; yea, himself hasted also to go out, because the LORD had smitten him.",
        },
        {
          verse: "21",
          text: "And Uzziah the king was a leper unto the day of his death, and dwelt in a several house, being a leper; for he was cut off from the house of the LORD: and Jotham his son was over the king\u2019s house, judging the people of the land.",
        },
        {
          verse: "22",
          text: "Now the rest of the acts of Uzziah, first and last, did Isaiah the prophet, the son of Amoz, write.",
        },
        {
          verse: "23",
          text: "So Uzziah slept with his fathers, and they buried him with his fathers in the field of the burial which belonged to the kings; for they said, He is a leper: and Jotham his son reigned in his stead.",
        },
      ],
    },
    {
      chapter: "27",
      verses: [
        {
          verse: "1",
          text: "Jotham was twenty and five years old when he began to reign, and he reigned sixteen years in Jerusalem. His mother\u2019s name also was Jerushah, the daughter of Zadok.",
        },
        {
          verse: "2",
          text: "And he did that which was right in the sight of the LORD, according to all that his father Uzziah did: howbeit he entered not into the temple of the LORD. And the people did yet corruptly.",
        },
        {
          verse: "3",
          text: "He built the high gate of the house of the LORD, and on the wall of Ophel he built much.",
        },
        {
          verse: "4",
          text: "Moreover he built cities in the mountains of Judah, and in the forests he built castles and towers.",
        },
        {
          verse: "5",
          text: "He fought also with the king of the Ammonites, and prevailed against them. And the children of Ammon gave him the same year an hundred talents of silver, and ten thousand measures of wheat, and ten thousand of barley. So much did the children of Ammon pay unto him, both the second year, and the third.",
        },
        {
          verse: "6",
          text: "So Jotham became mighty, because he prepared his ways before the LORD his God.",
        },
        {
          verse: "7",
          text: "Now the rest of the acts of Jotham, and all his wars, and his ways, lo, they are written in the book of the kings of Israel and Judah.",
        },
        {
          verse: "8",
          text: "He was five and twenty years old when he began to reign, and reigned sixteen years in Jerusalem.",
        },
        {
          verse: "9",
          text: "And Jotham slept with his fathers, and they buried him in the city of David: and Ahaz his son reigned in his stead.",
        },
      ],
    },
    {
      chapter: "28",
      verses: [
        {
          verse: "1",
          text: "Ahaz was twenty years old when he began to reign, and he reigned sixteen years in Jerusalem: but he did not that which was right in the sight of the LORD, like David his father:",
        },
        {
          verse: "2",
          text: "For he walked in the ways of the kings of Israel, and made also molten images for Baalim.",
        },
        {
          verse: "3",
          text: "Moreover he burnt incense in the valley of the son of Hinnom, and burnt his children in the fire, after the abominations of the heathen whom the LORD had cast out before the children of Israel.",
        },
        {
          verse: "4",
          text: "He sacrificed also and burnt incense in the high places, and on the hills, and under every green tree.",
        },
        {
          verse: "5",
          text: "Wherefore the LORD his God delivered him into the hand of the king of Syria; and they smote him, and carried away a great multitude of them captives, and brought them to Damascus. And he was also delivered into the hand of the king of Israel, who smote him with a great slaughter.",
        },
        {
          verse: "6",
          text: "For Pekah the son of Remaliah slew in Judah an hundred and twenty thousand in one day, which were all valiant men; because they had forsaken the LORD God of their fathers.",
        },
        {
          verse: "7",
          text: "And Zichri, a mighty man of Ephraim, slew Maaseiah the king\u2019s son, and Azrikam the governor of the house, and Elkanah that was next to the king.",
        },
        {
          verse: "8",
          text: "And the children of Israel carried away captive of their brethren two hundred thousand, women, sons, and daughters, and took also away much spoil from them, and brought the spoil to Samaria.",
        },
        {
          verse: "9",
          text: "But a prophet of the LORD was there, whose name was Oded: and he went out before the host that came to Samaria, and said unto them, Behold, because the LORD God of your fathers was wroth with Judah, he hath delivered them into your hand, and ye have slain them in a rage that reacheth up unto heaven.",
        },
        {
          verse: "10",
          text: "And now ye purpose to keep under the children of Judah and Jerusalem for bondmen and bondwomen unto you: but are there not with you, even with you, sins against the LORD your God?",
        },
        {
          verse: "11",
          text: "Now hear me therefore, and deliver the captives again, which ye have taken captive of your brethren: for the fierce wrath of the LORD is upon you.",
        },
        {
          verse: "12",
          text: "Then certain of the heads of the children of Ephraim, Azariah the son of Johanan, Berechiah the son of Meshillemoth, and Jehizkiah the son of Shallum, and Amasa the son of Hadlai, stood up against them that came from the war,",
        },
        {
          verse: "13",
          text: "And said unto them, Ye shall not bring in the captives hither: for whereas we have offended against the LORD already, ye intend to add more to our sins and to our trespass: for our trespass is great, and there is fierce wrath against Israel.",
        },
        {
          verse: "14",
          text: "So the armed men left the captives and the spoil before the princes and all the congregation.",
        },
        {
          verse: "15",
          text: "And the men which were expressed by name rose up, and took the captives, and with the spoil clothed all that were naked among them, and arrayed them, and shod them, and gave them to eat and to drink, and anointed them, and carried all the feeble of them upon asses, and brought them to Jericho, the city of palm trees, to their brethren: then they returned to Samaria.",
        },
        {
          verse: "16",
          text: "At that time did king Ahaz send unto the kings of Assyria to help him.",
        },
        {
          verse: "17",
          text: "For again the Edomites had come and smitten Judah, and carried away captives.",
        },
        {
          verse: "18",
          text: "The Philistines also had invaded the cities of the low country, and of the south of Judah, and had taken Bethshemesh, and Ajalon, and Gederoth, and Shocho with the villages thereof, and Timnah with the villages thereof, Gimzo also and the villages thereof: and they dwelt there.",
        },
        {
          verse: "19",
          text: "For the LORD brought Judah low because of Ahaz king of Israel; for he made Judah naked, and transgressed sore against the LORD.",
        },
        {
          verse: "20",
          text: "And Tilgathpilneser king of Assyria came unto him, and distressed him, but strengthened him not.",
        },
        {
          verse: "21",
          text: "For Ahaz took away a portion out of the house of the LORD, and out of the house of the king, and of the princes, and gave it unto the king of Assyria: but he helped him not.",
        },
        {
          verse: "22",
          text: "And in the time of his distress did he trespass yet more against the LORD: this is that king Ahaz.",
        },
        {
          verse: "23",
          text: "For he sacrificed unto the gods of Damascus, which smote him: and he said, Because the gods of the kings of Syria help them, therefore will I sacrifice to them, that they may help me. But they were the ruin of him, and of all Israel.",
        },
        {
          verse: "24",
          text: "And Ahaz gathered together the vessels of the house of God, and cut in pieces the vessels of the house of God, and shut up the doors of the house of the LORD, and he made him altars in every corner of Jerusalem.",
        },
        {
          verse: "25",
          text: "And in every several city of Judah he made high places to burn incense unto other gods, and provoked to anger the LORD God of his fathers.",
        },
        {
          verse: "26",
          text: "Now the rest of his acts and of all his ways, first and last, behold, they are written in the book of the kings of Judah and Israel.",
        },
        {
          verse: "27",
          text: "And Ahaz slept with his fathers, and they buried him in the city, even in Jerusalem: but they brought him not into the sepulchres of the kings of Israel: and Hezekiah his son reigned in his stead.",
        },
      ],
    },
    {
      chapter: "29",
      verses: [
        {
          verse: "1",
          text: "Hezekiah began to reign when he was five and twenty years old, and he reigned nine and twenty years in Jerusalem. And his mother\u2019s name was Abijah, the daughter of Zechariah.",
        },
        {
          verse: "2",
          text: "And he did that which was right in the sight of the LORD, according to all that David his father had done.",
        },
        {
          verse: "3",
          text: "He in the first year of his reign, in the first month, opened the doors of the house of the LORD, and repaired them.",
        },
        {
          verse: "4",
          text: "And he brought in the priests and the Levites, and gathered them together into the east street,",
        },
        {
          verse: "5",
          text: "And said unto them, Hear me, ye Levites, sanctify now yourselves, and sanctify the house of the LORD God of your fathers, and carry forth the filthiness out of the holy place.",
        },
        {
          verse: "6",
          text: "For our fathers have trespassed, and done that which was evil in the eyes of the LORD our God, and have forsaken him, and have turned away their faces from the habitation of the LORD, and turned their backs.",
        },
        {
          verse: "7",
          text: "Also they have shut up the doors of the porch, and put out the lamps, and have not burned incense nor offered burnt offerings in the holy place unto the God of Israel.",
        },
        {
          verse: "8",
          text: "Wherefore the wrath of the LORD was upon Judah and Jerusalem, and he hath delivered them to trouble, to astonishment, and to hissing, as ye see with your eyes.",
        },
        {
          verse: "9",
          text: "For, lo, our fathers have fallen by the sword, and our sons and our daughters and our wives are in captivity for this.",
        },
        {
          verse: "10",
          text: "Now it is in mine heart to make a covenant with the LORD God of Israel, that his fierce wrath may turn away from us.",
        },
        {
          verse: "11",
          text: "My sons, be not now negligent: for the LORD hath chosen you to stand before him, to serve him, and that ye should minister unto him, and burn incense.",
        },
        {
          verse: "12",
          text: "Then the Levites arose, Mahath the son of Amasai, and Joel the son of Azariah, of the sons of the Kohathites: and of the sons of Merari, Kish the son of Abdi, and Azariah the son of Jehalelel: and of the Gershonites; Joah the son of Zimmah, and Eden the son of Joah:",
        },
        {
          verse: "13",
          text: "And of the sons of Elizaphan; Shimri, and Jeiel: and of the sons of Asaph; Zechariah, and Mattaniah:",
        },
        {
          verse: "14",
          text: "And of the sons of Heman; Jehiel, and Shimei: and of the sons of Jeduthun; Shemaiah, and Uzziel.",
        },
        {
          verse: "15",
          text: "And they gathered their brethren, and sanctified themselves, and came, according to the commandment of the king, by the words of the LORD, to cleanse the house of the LORD.",
        },
        {
          verse: "16",
          text: "And the priests went into the inner part of the house of the LORD, to cleanse it, and brought out all the uncleanness that they found in the temple of the LORD into the court of the house of the LORD. And the Levites took it, to carry it out abroad into the brook Kidron.",
        },
        {
          verse: "17",
          text: "Now they began on the first day of the first month to sanctify, and on the eighth day of the month came they to the porch of the LORD: so they sanctified the house of the LORD in eight days; and in the sixteenth day of the first month they made an end.",
        },
        {
          verse: "18",
          text: "Then they went in to Hezekiah the king, and said, We have cleansed all the house of the LORD, and the altar of burnt offering, with all the vessels thereof, and the shewbread table, with all the vessels thereof.",
        },
        {
          verse: "19",
          text: "Moreover all the vessels, which king Ahaz in his reign did cast away in his transgression, have we prepared and sanctified, and, behold, they are before the altar of the LORD.",
        },
        {
          verse: "20",
          text: "Then Hezekiah the king rose early, and gathered the rulers of the city, and went up to the house of the LORD.",
        },
        {
          verse: "21",
          text: "And they brought seven bullocks, and seven rams, and seven lambs, and seven he goats, for a sin offering for the kingdom, and for the sanctuary, and for Judah. And he commanded the priests the sons of Aaron to offer them on the altar of the LORD.",
        },
        {
          verse: "22",
          text: "So they killed the bullocks, and the priests received the blood, and sprinkled it on the altar: likewise, when they had killed the rams, they sprinkled the blood upon the altar: they killed also the lambs, and they sprinkled the blood upon the altar.",
        },
        {
          verse: "23",
          text: "And they brought forth the he goats for the sin offering before the king and the congregation; and they laid their hands upon them:",
        },
        {
          verse: "24",
          text: "And the priests killed them, and they made reconciliation with their blood upon the altar, to make an atonement for all Israel: for the king commanded that the burnt offering and the sin offering should be made for all Israel.",
        },
        {
          verse: "25",
          text: "And he set the Levites in the house of the LORD with cymbals, with psalteries, and with harps, according to the commandment of David, and of Gad the king\u2019s seer, and Nathan the prophet: for so was the commandment of the LORD by his prophets.",
        },
        {
          verse: "26",
          text: "And the Levites stood with the instruments of David, and the priests with the trumpets.",
        },
        {
          verse: "27",
          text: "And Hezekiah commanded to offer the burnt offering upon the altar. And when the burnt offering began, the song of the LORD began also with the trumpets, and with the instruments ordained by David king of Israel.",
        },
        {
          verse: "28",
          text: "And all the congregation worshipped, and the singers sang, and the trumpeters sounded: and all this continued until the burnt offering was finished.",
        },
        {
          verse: "29",
          text: "And when they had made an end of offering, the king and all that were present with him bowed themselves, and worshipped.",
        },
        {
          verse: "30",
          text: "Moreover Hezekiah the king and the princes commanded the Levites to sing praise unto the LORD with the words of David, and of Asaph the seer. And they sang praises with gladness, and they bowed their heads and worshipped.",
        },
        {
          verse: "31",
          text: "Then Hezekiah answered and said, Now ye have consecrated yourselves unto the LORD, come near and bring sacrifices and thank offerings into the house of the LORD. And the congregation brought in sacrifices and thank offerings; and as many as were of a free heart burnt offerings.",
        },
        {
          verse: "32",
          text: "And the number of the burnt offerings, which the congregation brought, was threescore and ten bullocks, an hundred rams, and two hundred lambs: all these were for a burnt offering to the LORD.",
        },
        {
          verse: "33",
          text: "And the consecrated things were six hundred oxen and three thousand sheep.",
        },
        {
          verse: "34",
          text: "But the priests were too few, so that they could not flay all the burnt offerings: wherefore their brethren the Levites did help them, till the work was ended, and until the other priests had sanctified themselves: for the Levites were more upright in heart to sanctify themselves than the priests.",
        },
        {
          verse: "35",
          text: "And also the burnt offerings were in abundance, with the fat of the peace offerings, and the drink offerings for every burnt offering. So the service of the house of the LORD was set in order.",
        },
        {
          verse: "36",
          text: "And Hezekiah rejoiced, and all the people, that God had prepared the people: for the thing was done suddenly.",
        },
      ],
    },
    {
      chapter: "30",
      verses: [
        {
          verse: "1",
          text: "And Hezekiah sent to all Israel and Judah, and wrote letters also to Ephraim and Manasseh, that they should come to the house of the LORD at Jerusalem, to keep the passover unto the LORD God of Israel.",
        },
        {
          verse: "2",
          text: "For the king had taken counsel, and his princes, and all the congregation in Jerusalem, to keep the passover in the second month.",
        },
        {
          verse: "3",
          text: "For they could not keep it at that time, because the priests had not sanctified themselves sufficiently, neither had the people gathered themselves together to Jerusalem.",
        },
        {
          verse: "4",
          text: "And the thing pleased the king and all the congregation.",
        },
        {
          verse: "5",
          text: "So they established a decree to make proclamation throughout all Israel, from Beersheba even to Dan, that they should come to keep the passover unto the LORD God of Israel at Jerusalem: for they had not done it of a long time in such sort as it was written.",
        },
        {
          verse: "6",
          text: "So the posts went with the letters from the king and his princes throughout all Israel and Judah, and according to the commandment of the king, saying, Ye children of Israel, turn again unto the LORD God of Abraham, Isaac, and Israel, and he will return to the remnant of you, that are escaped out of the hand of the kings of Assyria.",
        },
        {
          verse: "7",
          text: "And be not ye like your fathers, and like your brethren, which trespassed against the LORD God of their fathers, who therefore gave them up to desolation, as ye see.",
        },
        {
          verse: "8",
          text: "Now be ye not stiffnecked, as your fathers were, but yield yourselves unto the LORD, and enter into his sanctuary, which he hath sanctified for ever: and serve the LORD your God, that the fierceness of his wrath may turn away from you.",
        },
        {
          verse: "9",
          text: "For if ye turn again unto the LORD, your brethren and your children shall find compassion before them that lead them captive, so that they shall come again into this land: for the LORD your God is gracious and merciful, and will not turn away his face from you, if ye return unto him.",
        },
        {
          verse: "10",
          text: "So the posts passed from city to city through the country of Ephraim and Manasseh even unto Zebulun: but they laughed them to scorn, and mocked them.",
        },
        {
          verse: "11",
          text: "Nevertheless divers of Asher and Manasseh and of Zebulun humbled themselves, and came to Jerusalem.",
        },
        {
          verse: "12",
          text: "Also in Judah the hand of God was to give them one heart to do the commandment of the king and of the princes, by the word of the LORD.",
        },
        {
          verse: "13",
          text: "And there assembled at Jerusalem much people to keep the feast of unleavened bread in the second month, a very great congregation.",
        },
        {
          verse: "14",
          text: "And they arose and took away the altars that were in Jerusalem, and all the altars for incense took they away, and cast them into the brook Kidron.",
        },
        {
          verse: "15",
          text: "Then they killed the passover on the fourteenth day of the second month: and the priests and the Levites were ashamed, and sanctified themselves, and brought in the burnt offerings into the house of the LORD.",
        },
        {
          verse: "16",
          text: "And they stood in their place after their manner, according to the law of Moses the man of God: the priests sprinkled the blood, which they received of the hand of the Levites.",
        },
        {
          verse: "17",
          text: "For there were many in the congregation that were not sanctified: therefore the Levites had the charge of the killing of the passovers for every one that was not clean, to sanctify them unto the LORD.",
        },
        {
          verse: "18",
          text: "For a multitude of the people, even many of Ephraim, and Manasseh, Issachar, and Zebulun, had not cleansed themselves, yet did they eat the passover otherwise than it was written. But Hezekiah prayed for them, saying, The good LORD pardon every one",
        },
        {
          verse: "19",
          text: "That prepareth his heart to seek God, the LORD God of his fathers, though he be not cleansed according to the purification of the sanctuary.",
        },
        {
          verse: "20",
          text: "And the LORD hearkened to Hezekiah, and healed the people.",
        },
        {
          verse: "21",
          text: "And the children of Israel that were present at Jerusalem kept the feast of unleavened bread seven days with great gladness: and the Levites and the priests praised the LORD day by day, singing with loud instruments unto the LORD.",
        },
        {
          verse: "22",
          text: "And Hezekiah spake comfortably unto all the Levites that taught the good knowledge of the LORD: and they did eat throughout the feast seven days, offering peace offerings, and making confession to the LORD God of their fathers.",
        },
        {
          verse: "23",
          text: "And the whole assembly took counsel to keep other seven days: and they kept other seven days with gladness.",
        },
        {
          verse: "24",
          text: "For Hezekiah king of Judah did give to the congregation a thousand bullocks and seven thousand sheep; and the princes gave to the congregation a thousand bullocks and ten thousand sheep: and a great number of priests sanctified themselves.",
        },
        {
          verse: "25",
          text: "And all the congregation of Judah, with the priests and the Levites, and all the congregation that came out of Israel, and the strangers that came out of the land of Israel, and that dwelt in Judah, rejoiced.",
        },
        {
          verse: "26",
          text: "So there was great joy in Jerusalem: for since the time of Solomon the son of David king of Israel there was not the like in Jerusalem.",
        },
        {
          verse: "27",
          text: "Then the priests the Levites arose and blessed the people: and their voice was heard, and their prayer came up to his holy dwelling place, even unto heaven.",
        },
      ],
    },
    {
      chapter: "31",
      verses: [
        {
          verse: "1",
          text: "Now when all this was finished, all Israel that were present went out to the cities of Judah, and brake the images in pieces, and cut down the groves, and threw down the high places and the altars out of all Judah and Benjamin, in Ephraim also and Manasseh, until they had utterly destroyed them all. Then all the children of Israel returned, every man to his possession, into their own cities.",
        },
        {
          verse: "2",
          text: "And Hezekiah appointed the courses of the priests and the Levites after their courses, every man according to his service, the priests and Levites for burnt offerings and for peace offerings, to minister, and to give thanks, and to praise in the gates of the tents of the LORD.",
        },
        {
          verse: "3",
          text: "He appointed also the king\u2019s portion of his substance for the burnt offerings, to wit, for the morning and evening burnt offerings, and the burnt offerings for the sabbaths, and for the new moons, and for the set feasts, as it is written in the law of the LORD.",
        },
        {
          verse: "4",
          text: "Moreover he commanded the people that dwelt in Jerusalem to give the portion of the priests and the Levites, that they might be encouraged in the law of the LORD.",
        },
        {
          verse: "5",
          text: "And as soon as the commandment came abroad, the children of Israel brought in abundance the firstfruits of corn, wine, and oil, and honey, and of all the increase of the field; and the tithe of all things brought they in abundantly.",
        },
        {
          verse: "6",
          text: "And concerning the children of Israel and Judah, that dwelt in the cities of Judah, they also brought in the tithe of oxen and sheep, and the tithe of holy things which were consecrated unto the LORD their God, and laid them by heaps.",
        },
        {
          verse: "7",
          text: "In the third month they began to lay the foundation of the heaps, and finished them in the seventh month.",
        },
        {
          verse: "8",
          text: "And when Hezekiah and the princes came and saw the heaps, they blessed the LORD, and his people Israel.",
        },
        {
          verse: "9",
          text: "Then Hezekiah questioned with the priests and the Levites concerning the heaps.",
        },
        {
          verse: "10",
          text: "And Azariah the chief priest of the house of Zadok answered him, and said, Since the people began to bring the offerings into the house of the LORD, we have had enough to eat, and have left plenty: for the LORD hath blessed his people; and that which is left is this great store.",
        },
        {
          verse: "11",
          text: "Then Hezekiah commanded to prepare chambers in the house of the LORD; and they prepared them,",
        },
        {
          verse: "12",
          text: "And brought in the offerings and the tithes and the dedicated things faithfully: over which Cononiah the Levite was ruler, and Shimei his brother was the next.",
        },
        {
          verse: "13",
          text: "And Jehiel, and Azaziah, and Nahath, and Asahel, and Jerimoth, and Jozabad, and Eliel, and Ismachiah, and Mahath, and Benaiah, were overseers under the hand of Cononiah and Shimei his brother, at the commandment of Hezekiah the king, and Azariah the ruler of the house of God.",
        },
        {
          verse: "14",
          text: "And Kore the son of Imnah the Levite, the porter toward the east, was over the freewill offerings of God, to distribute the oblations of the LORD, and the most holy things.",
        },
        {
          verse: "15",
          text: "And next him were Eden, and Miniamin, and Jeshua, and Shemaiah, Amariah, and Shecaniah, in the cities of the priests, in their set office, to give to their brethren by courses, as well to the great as to the small:",
        },
        {
          verse: "16",
          text: "Beside their genealogy of males, from three years old and upward, even unto every one that entereth into the house of the LORD, his daily portion for their service in their charges according to their courses;",
        },
        {
          verse: "17",
          text: "Both to the genealogy of the priests by the house of their fathers, and the Levites from twenty years old and upward, in their charges by their courses;",
        },
        {
          verse: "18",
          text: "And to the genealogy of all their little ones, their wives, and their sons, and their daughters, through all the congregation: for in their set office they sanctified themselves in holiness:",
        },
        {
          verse: "19",
          text: "Also of the sons of Aaron the priests, which were in the fields of the suburbs of their cities, in every several city, the men that were expressed by name, to give portions to all the males among the priests, and to all that were reckoned by genealogies among the Levites.",
        },
        {
          verse: "20",
          text: "And thus did Hezekiah throughout all Judah, and wrought that which was good and right and truth before the LORD his God.",
        },
        {
          verse: "21",
          text: "And in every work that he began in the service of the house of God, and in the law, and in the commandments, to seek his God, he did it with all his heart, and prospered.",
        },
      ],
    },
    {
      chapter: "32",
      verses: [
        {
          verse: "1",
          text: "After these things, and the establishment thereof, Sennacherib king of Assyria came, and entered into Judah, and encamped against the fenced cities, and thought to win them for himself.",
        },
        {
          verse: "2",
          text: "And when Hezekiah saw that Sennacherib was come, and that he was purposed to fight against Jerusalem,",
        },
        {
          verse: "3",
          text: "He took counsel with his princes and his mighty men to stop the waters of the fountains which were without the city: and they did help him.",
        },
        {
          verse: "4",
          text: "So there was gathered much people together, who stopped all the fountains, and the brook that ran through the midst of the land, saying, Why should the kings of Assyria come, and find much water?",
        },
        {
          verse: "5",
          text: "Also he strengthened himself, and built up all the wall that was broken, and raised it up to the towers, and another wall without, and repaired Millo in the city of David, and made darts and shields in abundance.",
        },
        {
          verse: "6",
          text: "And he set captains of war over the people, and gathered them together to him in the street of the gate of the city, and spake comfortably to them, saying,",
        },
        {
          verse: "7",
          text: "Be strong and courageous, be not afraid nor dismayed for the king of Assyria, nor for all the multitude that is with him: for there be more with us than with him:",
        },
        {
          verse: "8",
          text: "With him is an arm of flesh; but with us is the LORD our God to help us, and to fight our battles. And the people rested themselves upon the words of Hezekiah king of Judah.",
        },
        {
          verse: "9",
          text: "After this did Sennacherib king of Assyria send his servants to Jerusalem, (but he himself laid siege against Lachish, and all his power with him,) unto Hezekiah king of Judah, and unto all Judah that were at Jerusalem, saying,",
        },
        {
          verse: "10",
          text: "Thus saith Sennacherib king of Assyria, Whereon do ye trust, that ye abide in the siege in Jerusalem?",
        },
        {
          verse: "11",
          text: "Doth not Hezekiah persuade you to give over yourselves to die by famine and by thirst, saying, The LORD our God shall deliver us out of the hand of the king of Assyria?",
        },
        {
          verse: "12",
          text: "Hath not the same Hezekiah taken away his high places and his altars, and commanded Judah and Jerusalem, saying, Ye shall worship before one altar, and burn incense upon it?",
        },
        {
          verse: "13",
          text: "Know ye not what I and my fathers have done unto all the people of other lands? were the gods of the nations of those lands any ways able to deliver their lands out of mine hand?",
        },
        {
          verse: "14",
          text: "Who was there among all the gods of those nations that my fathers utterly destroyed, that could deliver his people out of mine hand, that your God should be able to deliver you out of mine hand?",
        },
        {
          verse: "15",
          text: "Now therefore let not Hezekiah deceive you, nor persuade you on this manner, neither yet believe him: for no god of any nation or kingdom was able to deliver his people out of mine hand, and out of the hand of my fathers: how much less shall your God deliver you out of mine hand?",
        },
        {
          verse: "16",
          text: "And his servants spake yet more against the LORD God, and against his servant Hezekiah.",
        },
        {
          verse: "17",
          text: "He wrote also letters to rail on the LORD God of Israel, and to speak against him, saying, As the gods of the nations of other lands have not delivered their people out of mine hand, so shall not the God of Hezekiah deliver his people out of mine hand.",
        },
        {
          verse: "18",
          text: "Then they cried with a loud voice in the Jews\u2019 speech unto the people of Jerusalem that were on the wall, to affright them, and to trouble them; that they might take the city.",
        },
        {
          verse: "19",
          text: "And they spake against the God of Jerusalem, as against the gods of the people of the earth, which were the work of the hands of man.",
        },
        {
          verse: "20",
          text: "And for this cause Hezekiah the king, and the prophet Isaiah the son of Amoz, prayed and cried to heaven.",
        },
        {
          verse: "21",
          text: "And the LORD sent an angel, which cut off all the mighty men of valour, and the leaders and captains in the camp of the king of Assyria. So he returned with shame of face to his own land. And when he was come into the house of his god, they that came forth of his own bowels slew him there with the sword.",
        },
        {
          verse: "22",
          text: "Thus the LORD saved Hezekiah and the inhabitants of Jerusalem from the hand of Sennacherib the king of Assyria, and from the hand of all other, and guided them on every side.",
        },
        {
          verse: "23",
          text: "And many brought gifts unto the LORD to Jerusalem, and presents to Hezekiah king of Judah: so that he was magnified in the sight of all nations from thenceforth.",
        },
        {
          verse: "24",
          text: "In those days Hezekiah was sick to the death, and prayed unto the LORD: and he spake unto him, and he gave him a sign.",
        },
        {
          verse: "25",
          text: "But Hezekiah rendered not again according to the benefit done unto him; for his heart was lifted up: therefore there was wrath upon him, and upon Judah and Jerusalem.",
        },
        {
          verse: "26",
          text: "Notwithstanding Hezekiah humbled himself for the pride of his heart, both he and the inhabitants of Jerusalem, so that the wrath of the LORD came not upon them in the days of Hezekiah.",
        },
        {
          verse: "27",
          text: "And Hezekiah had exceeding much riches and honour: and he made himself treasuries for silver, and for gold, and for precious stones, and for spices, and for shields, and for all manner of pleasant jewels;",
        },
        {
          verse: "28",
          text: "Storehouses also for the increase of corn, and wine, and oil; and stalls for all manner of beasts, and cotes for flocks.",
        },
        {
          verse: "29",
          text: "Moreover he provided him cities, and possessions of flocks and herds in abundance: for God had given him substance very much.",
        },
        {
          verse: "30",
          text: "This same Hezekiah also stopped the upper watercourse of Gihon, and brought it straight down to the west side of the city of David. And Hezekiah prospered in all his works.",
        },
        {
          verse: "31",
          text: "Howbeit in the business of the ambassadors of the princes of Babylon, who sent unto him to enquire of the wonder that was done in the land, God left him, to try him, that he might know all that was in his heart.",
        },
        {
          verse: "32",
          text: "Now the rest of the acts of Hezekiah, and his goodness, behold, they are written in the vision of Isaiah the prophet, the son of Amoz, and in the book of the kings of Judah and Israel.",
        },
        {
          verse: "33",
          text: "And Hezekiah slept with his fathers, and they buried him in the chiefest of the sepulchres of the sons of David: and all Judah and the inhabitants of Jerusalem did him honour at his death. And Manasseh his son reigned in his stead.",
        },
      ],
    },
    {
      chapter: "33",
      verses: [
        {
          verse: "1",
          text: "Manasseh was twelve years old when he began to reign, and he reigned fifty and five years in Jerusalem:",
        },
        {
          verse: "2",
          text: "But did that which was evil in the sight of the LORD, like unto the abominations of the heathen, whom the LORD had cast out before the children of Israel.",
        },
        {
          verse: "3",
          text: "For he built again the high places which Hezekiah his father had broken down, and he reared up altars for Baalim, and made groves, and worshipped all the host of heaven, and served them.",
        },
        {
          verse: "4",
          text: "Also he built altars in the house of the LORD, whereof the LORD had said, In Jerusalem shall my name be for ever.",
        },
        {
          verse: "5",
          text: "And he built altars for all the host of heaven in the two courts of the house of the LORD.",
        },
        {
          verse: "6",
          text: "And he caused his children to pass through the fire in the valley of the son of Hinnom: also he observed times, and used enchantments, and used witchcraft, and dealt with a familiar spirit, and with wizards: he wrought much evil in the sight of the LORD, to provoke him to anger.",
        },
        {
          verse: "7",
          text: "And he set a carved image, the idol which he had made, in the house of God, of which God had said to David and to Solomon his son, In this house, and in Jerusalem, which I have chosen before all the tribes of Israel, will I put my name for ever:",
        },
        {
          verse: "8",
          text: "Neither will I any more remove the foot of Israel from out of the land which I have appointed for your fathers; so that they will take heed to do all that I have commanded them, according to the whole law and the statutes and the ordinances by the hand of Moses.",
        },
        {
          verse: "9",
          text: "So Manasseh made Judah and the inhabitants of Jerusalem to err, and to do worse than the heathen, whom the LORD had destroyed before the children of Israel.",
        },
        {
          verse: "10",
          text: "And the LORD spake to Manasseh, and to his people: but they would not hearken.",
        },
        {
          verse: "11",
          text: "Wherefore the LORD brought upon them the captains of the host of the king of Assyria, which took Manasseh among the thorns, and bound him with fetters, and carried him to Babylon.",
        },
        {
          verse: "12",
          text: "And when he was in affliction, he besought the LORD his God, and humbled himself greatly before the God of his fathers,",
        },
        {
          verse: "13",
          text: "And prayed unto him: and he was intreated of him, and heard his supplication, and brought him again to Jerusalem into his kingdom. Then Manasseh knew that the LORD he was God.",
        },
        {
          verse: "14",
          text: "Now after this he built a wall without the city of David, on the west side of Gihon, in the valley, even to the entering in at the fish gate, and compassed about Ophel, and raised it up a very great height, and put captains of war in all the fenced cities of Judah.",
        },
        {
          verse: "15",
          text: "And he took away the strange gods, and the idol out of the house of the LORD, and all the altars that he had built in the mount of the house of the LORD, and in Jerusalem, and cast them out of the city.",
        },
        {
          verse: "16",
          text: "And he repaired the altar of the LORD, and sacrificed thereon peace offerings and thank offerings, and commanded Judah to serve the LORD God of Israel.",
        },
        {
          verse: "17",
          text: "Nevertheless the people did sacrifice still in the high places, yet unto the LORD their God only.",
        },
        {
          verse: "18",
          text: "Now the rest of the acts of Manasseh, and his prayer unto his God, and the words of the seers that spake to him in the name of the LORD God of Israel, behold, they are written in the book of the kings of Israel.",
        },
        {
          verse: "19",
          text: "His prayer also, and how God was intreated of him, and all his sins, and his trespass, and the places wherein he built high places, and set up groves and graven images, before he was humbled: behold, they are written among the sayings of the seers.",
        },
        {
          verse: "20",
          text: "So Manasseh slept with his fathers, and they buried him in his own house: and Amon his son reigned in his stead.",
        },
        {
          verse: "21",
          text: "Amon was two and twenty years old when he began to reign, and reigned two years in Jerusalem.",
        },
        {
          verse: "22",
          text: "But he did that which was evil in the sight of the LORD, as did Manasseh his father: for Amon sacrificed unto all the carved images which Manasseh his father had made, and served them;",
        },
        {
          verse: "23",
          text: "And humbled not himself before the LORD, as Manasseh his father had humbled himself; but Amon trespassed more and more.",
        },
        {
          verse: "24",
          text: "And his servants conspired against him, and slew him in his own house.",
        },
        {
          verse: "25",
          text: "But the people of the land slew all them that had conspired against king Amon; and the people of the land made Josiah his son king in his stead.",
        },
      ],
    },
    {
      chapter: "34",
      verses: [
        {
          verse: "1",
          text: "Josiah was eight years old when he began to reign, and he reigned in Jerusalem one and thirty years.",
        },
        {
          verse: "2",
          text: "And he did that which was right in the sight of the LORD, and walked in the ways of David his father, and declined neither to the right hand, nor to the left.",
        },
        {
          verse: "3",
          text: "For in the eighth year of his reign, while he was yet young, he began to seek after the God of David his father: and in the twelfth year he began to purge Judah and Jerusalem from the high places, and the groves, and the carved images, and the molten images.",
        },
        {
          verse: "4",
          text: "And they brake down the altars of Baalim in his presence; and the images, that were on high above them, he cut down; and the groves, and the carved images, and the molten images, he brake in pieces, and made dust of them, and strowed it upon the graves of them that had sacrificed unto them.",
        },
        {
          verse: "5",
          text: "And he burnt the bones of the priests upon their altars, and cleansed Judah and Jerusalem.",
        },
        {
          verse: "6",
          text: "And so did he in the cities of Manasseh, and Ephraim, and Simeon, even unto Naphtali, with their mattocks round about.",
        },
        {
          verse: "7",
          text: "And when he had broken down the altars and the groves, and had beaten the graven images into powder, and cut down all the idols throughout all the land of Israel, he returned to Jerusalem.",
        },
        {
          verse: "8",
          text: "Now in the eighteenth year of his reign, when he had purged the land, and the house, he sent Shaphan the son of Azaliah, and Maaseiah the governor of the city, and Joah the son of Joahaz the recorder, to repair the house of the LORD his God.",
        },
        {
          verse: "9",
          text: "And when they came to Hilkiah the high priest, they delivered the money that was brought into the house of God, which the Levites that kept the doors had gathered of the hand of Manasseh and Ephraim, and of all the remnant of Israel, and of all Judah and Benjamin; and they returned to Jerusalem.",
        },
        {
          verse: "10",
          text: "And they put it in the hand of the workmen that had the oversight of the house of the LORD, and they gave it to the workmen that wrought in the house of the LORD, to repair and amend the house:",
        },
        {
          verse: "11",
          text: "Even to the artificers and builders gave they it, to buy hewn stone, and timber for couplings, and to floor the houses which the kings of Judah had destroyed.",
        },
        {
          verse: "12",
          text: "And the men did the work faithfully: and the overseers of them were Jahath and Obadiah, the Levites, of the sons of Merari; and Zechariah and Meshullam, of the sons of the Kohathites, to set it forward; and other of the Levites, all that could skill of instruments of musick.",
        },
        {
          verse: "13",
          text: "Also they were over the bearers of burdens, and were overseers of all that wrought the work in any manner of service: and of the Levites there were scribes, and officers, and porters.",
        },
        {
          verse: "14",
          text: "And when they brought out the money that was brought into the house of the LORD, Hilkiah the priest found a book of the law of the LORD given by Moses.",
        },
        {
          verse: "15",
          text: "And Hilkiah answered and said to Shaphan the scribe, I have found the book of the law in the house of the LORD. And Hilkiah delivered the book to Shaphan.",
        },
        {
          verse: "16",
          text: "And Shaphan carried the book to the king, and brought the king word back again, saying, All that was committed to thy servants, they do it.",
        },
        {
          verse: "17",
          text: "And they have gathered together the money that was found in the house of the LORD, and have delivered it into the hand of the overseers, and to the hand of the workmen.",
        },
        {
          verse: "18",
          text: "Then Shaphan the scribe told the king, saying, Hilkiah the priest hath given me a book. And Shaphan read it before the king.",
        },
        {
          verse: "19",
          text: "And it came to pass, when the king had heard the words of the law, that he rent his clothes.",
        },
        {
          verse: "20",
          text: "And the king commanded Hilkiah, and Ahikam the son of Shaphan, and Abdon the son of Micah, and Shaphan the scribe, and Asaiah a servant of the king\u2019s, saying,",
        },
        {
          verse: "21",
          text: "Go, enquire of the LORD for me, and for them that are left in Israel and in Judah, concerning the words of the book that is found: for great is the wrath of the LORD that is poured out upon us, because our fathers have not kept the word of the LORD, to do after all that is written in this book.",
        },
        {
          verse: "22",
          text: "And Hilkiah, and they that the king had appointed, went to Huldah the prophetess, the wife of Shallum the son of Tikvath, the son of Hasrah, keeper of the wardrobe; (now she dwelt in Jerusalem in the college:) and they spake to her to that effect.",
        },
        {
          verse: "23",
          text: "And she answered them, Thus saith the LORD God of Israel, Tell ye the man that sent you to me,",
        },
        {
          verse: "24",
          text: "Thus saith the LORD, Behold, I will bring evil upon this place, and upon the inhabitants thereof, even all the curses that are written in the book which they have read before the king of Judah:",
        },
        {
          verse: "25",
          text: "Because they have forsaken me, and have burned incense unto other gods, that they might provoke me to anger with all the works of their hands; therefore my wrath shall be poured out upon this place, and shall not be quenched.",
        },
        {
          verse: "26",
          text: "And as for the king of Judah, who sent you to enquire of the LORD, so shall ye say unto him, Thus saith the LORD God of Israel concerning the words which thou hast heard;",
        },
        {
          verse: "27",
          text: "Because thine heart was tender, and thou didst humble thyself before God, when thou heardest his words against this place, and against the inhabitants thereof, and humbledst thyself before me, and didst rend thy clothes, and weep before me; I have even heard thee also, saith the LORD.",
        },
        {
          verse: "28",
          text: "Behold, I will gather thee to thy fathers, and thou shalt be gathered to thy grave in peace, neither shall thine eyes see all the evil that I will bring upon this place, and upon the inhabitants of the same. So they brought the king word again.",
        },
        {
          verse: "29",
          text: "Then the king sent and gathered together all the elders of Judah and Jerusalem.",
        },
        {
          verse: "30",
          text: "And the king went up into the house of the LORD, and all the men of Judah, and the inhabitants of Jerusalem, and the priests, and the Levites, and all the people, great and small: and he read in their ears all the words of the book of the covenant that was found in the house of the LORD.",
        },
        {
          verse: "31",
          text: "And the king stood in his place, and made a covenant before the LORD, to walk after the LORD, and to keep his commandments, and his testimonies, and his statutes, with all his heart, and with all his soul, to perform the words of the covenant which are written in this book.",
        },
        {
          verse: "32",
          text: "And he caused all that were present in Jerusalem and Benjamin to stand to it. And the inhabitants of Jerusalem did according to the covenant of God, the God of their fathers.",
        },
        {
          verse: "33",
          text: "And Josiah took away all the abominations out of all the countries that pertained to the children of Israel, and made all that were present in Israel to serve, even to serve the LORD their God. And all his days they departed not from following the LORD, the God of their fathers.",
        },
      ],
    },
    {
      chapter: "35",
      verses: [
        {
          verse: "1",
          text: "Moreover Josiah kept a passover unto the LORD in Jerusalem: and they killed the passover on the fourteenth day of the first month.",
        },
        {
          verse: "2",
          text: "And he set the priests in their charges, and encouraged them to the service of the house of the LORD,",
        },
        {
          verse: "3",
          text: "And said unto the Levites that taught all Israel, which were holy unto the LORD, Put the holy ark in the house which Solomon the son of David king of Israel did build; it shall not be a burden upon your shoulders: serve now the LORD your God, and his people Israel,",
        },
        {
          verse: "4",
          text: "And prepare yourselves by the houses of your fathers, after your courses, according to the writing of David king of Israel, and according to the writing of Solomon his son.",
        },
        {
          verse: "5",
          text: "And stand in the holy place according to the divisions of the families of the fathers of your brethren the people, and after the division of the families of the Levites.",
        },
        {
          verse: "6",
          text: "So kill the passover, and sanctify yourselves, and prepare your brethren, that they may do according to the word of the LORD by the hand of Moses.",
        },
        {
          verse: "7",
          text: "And Josiah gave to the people, of the flock, lambs and kids, all for the passover offerings, for all that were present, to the number of thirty thousand, and three thousand bullocks: these were of the king\u2019s substance.",
        },
        {
          verse: "8",
          text: "And his princes gave willingly unto the people, to the priests, and to the Levites: Hilkiah and Zechariah and Jehiel, rulers of the house of God, gave unto the priests for the passover offerings two thousand and six hundred small cattle, and three hundred oxen.",
        },
        {
          verse: "9",
          text: "Conaniah also, and Shemaiah and Nethaneel, his brethren, and Hashabiah and Jeiel and Jozabad, chief of the Levites, gave unto the Levites for passover offerings five thousand small cattle, and five hundred oxen.",
        },
        {
          verse: "10",
          text: "So the service was prepared, and the priests stood in their place, and the Levites in their courses, according to the king\u2019s commandment.",
        },
        {
          verse: "11",
          text: "And they killed the passover, and the priests sprinkled the blood from their hands, and the Levites flayed them.",
        },
        {
          verse: "12",
          text: "And they removed the burnt offerings, that they might give according to the divisions of the families of the people, to offer unto the LORD, as it is written in the book of Moses. And so did they with the oxen.",
        },
        {
          verse: "13",
          text: "And they roasted the passover with fire according to the ordinance: but the other holy offerings sod they in pots, and in caldrons, and in pans, and divided them speedily among all the people.",
        },
        {
          verse: "14",
          text: "And afterward they made ready for themselves, and for the priests: because the priests the sons of Aaron were busied in offering of burnt offerings and the fat until night; therefore the Levites prepared for themselves, and for the priests the sons of Aaron.",
        },
        {
          verse: "15",
          text: "And the singers the sons of Asaph were in their place, according to the commandment of David, and Asaph, and Heman, and Jeduthun the king\u2019s seer; and the porters waited at every gate; they might not depart from their service; for their brethren the Levites prepared for them.",
        },
        {
          verse: "16",
          text: "So all the service of the LORD was prepared the same day, to keep the passover, and to offer burnt offerings upon the altar of the LORD, according to the commandment of king Josiah.",
        },
        {
          verse: "17",
          text: "And the children of Israel that were present kept the passover at that time, and the feast of unleavened bread seven days.",
        },
        {
          verse: "18",
          text: "And there was no passover like to that kept in Israel from the days of Samuel the prophet; neither did all the kings of Israel keep such a passover as Josiah kept, and the priests, and the Levites, and all Judah and Israel that were present, and the inhabitants of Jerusalem.",
        },
        {
          verse: "19",
          text: "In the eighteenth year of the reign of Josiah was this passover kept.",
        },
        {
          verse: "20",
          text: "After all this, when Josiah had prepared the temple, Necho king of Egypt came up to fight against Charchemish by Euphrates: and Josiah went out against him.",
        },
        {
          verse: "21",
          text: "But he sent ambassadors to him, saying, What have I to do with thee, thou king of Judah? I come not against thee this day, but against the house wherewith I have war: for God commanded me to make haste: forbear thee from meddling with God, who is with me, that he destroy thee not.",
        },
        {
          verse: "22",
          text: "Nevertheless Josiah would not turn his face from him, but disguised himself, that he might fight with him, and hearkened not unto the words of Necho from the mouth of God, and came to fight in the valley of Megiddo.",
        },
        {
          verse: "23",
          text: "And the archers shot at king Josiah; and the king said to his servants, Have me away; for I am sore wounded.",
        },
        {
          verse: "24",
          text: "His servants therefore took him out of that chariot, and put him in the second chariot that he had; and they brought him to Jerusalem, and he died, and was buried in one of the sepulchres of his fathers. And all Judah and Jerusalem mourned for Josiah.",
        },
        {
          verse: "25",
          text: "And Jeremiah lamented for Josiah: and all the singing men and the singing women spake of Josiah in their lamentations to this day, and made them an ordinance in Israel: and, behold, they are written in the lamentations.",
        },
        {
          verse: "26",
          text: "Now the rest of the acts of Josiah, and his goodness, according to that which was written in the law of the LORD,",
        },
        {
          verse: "27",
          text: "And his deeds, first and last, behold, they are written in the book of the kings of Israel and Judah.",
        },
      ],
    },
    {
      chapter: "36",
      verses: [
        {
          verse: "1",
          text: "Then the people of the land took Jehoahaz the son of Josiah, and made him king in his father\u2019s stead in Jerusalem.",
        },
        {
          verse: "2",
          text: "Jehoahaz was twenty and three years old when he began to reign, and he reigned three months in Jerusalem.",
        },
        {
          verse: "3",
          text: "And the king of Egypt put him down at Jerusalem, and condemned the land in an hundred talents of silver and a talent of gold.",
        },
        {
          verse: "4",
          text: "And the king of Egypt made Eliakim his brother king over Judah and Jerusalem, and turned his name to Jehoiakim. And Necho took Jehoahaz his brother, and carried him to Egypt.",
        },
        {
          verse: "5",
          text: "Jehoiakim was twenty and five years old when he began to reign, and he reigned eleven years in Jerusalem: and he did that which was evil in the sight of the LORD his God.",
        },
        {
          verse: "6",
          text: "Against him came up Nebuchadnezzar king of Babylon, and bound him in fetters, to carry him to Babylon.",
        },
        {
          verse: "7",
          text: "Nebuchadnezzar also carried of the vessels of the house of the LORD to Babylon, and put them in his temple at Babylon.",
        },
        {
          verse: "8",
          text: "Now the rest of the acts of Jehoiakim, and his abominations which he did, and that which was found in him, behold, they are written in the book of the kings of Israel and Judah: and Jehoiachin his son reigned in his stead.",
        },
        {
          verse: "9",
          text: "Jehoiachin was eight years old when he began to reign, and he reigned three months and ten days in Jerusalem: and he did that which was evil in the sight of the LORD.",
        },
        {
          verse: "10",
          text: "And when the year was expired, king Nebuchadnezzar sent, and brought him to Babylon, with the goodly vessels of the house of the LORD, and made Zedekiah his brother king over Judah and Jerusalem.",
        },
        {
          verse: "11",
          text: "Zedekiah was one and twenty years old when he began to reign, and reigned eleven years in Jerusalem.",
        },
        {
          verse: "12",
          text: "And he did that which was evil in the sight of the LORD his God, and humbled not himself before Jeremiah the prophet speaking from the mouth of the LORD.",
        },
        {
          verse: "13",
          text: "And he also rebelled against king Nebuchadnezzar, who had made him swear by God: but he stiffened his neck, and hardened his heart from turning unto the LORD God of Israel.",
        },
        {
          verse: "14",
          text: "Moreover all the chief of the priests, and the people, transgressed very much after all the abominations of the heathen; and polluted the house of the LORD which he had hallowed in Jerusalem.",
        },
        {
          verse: "15",
          text: "And the LORD God of their fathers sent to them by his messengers, rising up betimes, and sending; because he had compassion on his people, and on his dwelling place:",
        },
        {
          verse: "16",
          text: "But they mocked the messengers of God, and despised his words, and misused his prophets, until the wrath of the LORD arose against his people, till there was no remedy.",
        },
        {
          verse: "17",
          text: "Therefore he brought upon them the king of the Chaldees, who slew their young men with the sword in the house of their sanctuary, and had no compassion upon young man or maiden, old man, or him that stooped for age: he gave them all into his hand.",
        },
        {
          verse: "18",
          text: "And all the vessels of the house of God, great and small, and the treasures of the house of the LORD, and the treasures of the king, and of his princes; all these he brought to Babylon.",
        },
        {
          verse: "19",
          text: "And they burnt the house of God, and brake down the wall of Jerusalem, and burnt all the palaces thereof with fire, and destroyed all the goodly vessels thereof.",
        },
        {
          verse: "20",
          text: "And them that had escaped from the sword carried he away to Babylon; where they were servants to him and his sons until the reign of the kingdom of Persia:",
        },
        {
          verse: "21",
          text: "To fulfil the word of the LORD by the mouth of Jeremiah, until the land had enjoyed her sabbaths: for as long as she lay desolate she kept sabbath, to fulfil threescore and ten years.",
        },
        {
          verse: "22",
          text: "Now in the first year of Cyrus king of Persia, that the word of the LORD spoken by the mouth of Jeremiah might be accomplished, the LORD stirred up the spirit of Cyrus king of Persia, that he made a proclamation throughout all his kingdom, and put it also in writing, saying,",
        },
        {
          verse: "23",
          text: "Thus saith Cyrus king of Persia, All the kingdoms of the earth hath the LORD God of heaven given me; and he hath charged me to build him an house in Jerusalem, which is in Judah. Who is there among you of all his people? The LORD his God be with him, and let him go up.",
        },
      ],
    },
  ],
};
